import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  contentEquals2jbsaphs7gxql as contentEquals,
  contentHashCode33l4yznfe2pz3 as contentHashCode,
  intArrayIterator15bt84fheeonh as intArrayIterator,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  contentEquals379bkuxwxaiqz as contentEquals_0,
  contentHashCode2dpr73siofp13 as contentHashCode_0,
  floatArrayIteratortsocm2kbztk as floatArrayIterator,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  println2shhhgwwt4c61 as println,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  Long2qws0ah9gnpki as Long,
  fromInt1lka3ktyu79a4 as fromInt,
  add85si75olwt6n as add,
  reverse2o3etdk6ug8y7 as reverse,
  createThis2j2avj17cvnv2 as createThis,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isIntArrayeijsubfngq38 as isIntArray,
  copyOf3rutauicler23 as copyOf,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  take8rd02inxauy8 as take,
  equals2au1ep9vhcato as equals,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  StringBuildermazzzhj6kkai as StringBuilder,
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  Collection1k04j3hzsbod0 as Collection,
  copyOfq9pcgcgbldck as copyOf_0,
  isFloatArrayjjscnqphw92j as isFloatArray,
  takeg3iw3d2yd8b4 as take_0,
  copyOfgossjg6lh6js as copyOf_1,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  takei63g8tyo7wy9 as take_1,
  asList2ho2pewtsfvv as asList,
  compareTo3ankvs086tmwq as compareTo,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  isArray1hxjqtqy632bc as isArray,
  toList3jhuyej2anx2q as toList,
  until1jbpn0z3f8lbg as until,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  to2cs3ny02qtbcb as to,
  KtMap140uvy3s5zad8 as KtMap,
  hashCodeq5arwsb9dgti as hashCode,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  AbstractMutableSetthfi6jds1k2h as AbstractMutableSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
  joinToString1cxrrlmo0chqs as joinToString,
  Iterable1y3qizuf89iou as Iterable,
  copyOf2ng0t8oizk6it as copyOf_2,
  toString30pk9tzaqopn as toString_0,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  reversed3cb5fwpceefdb as reversed,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  toSet2orjxp16sotqu as toSet,
  contentEqualsaf55p28mnw74 as contentEquals_1,
  contentHashCode2i020q5tbeh2s as contentHashCode_1,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  toRawBits2035dtuolth0v as toRawBits,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  getOrNull1go7ef9ldk0df as getOrNull,
  step18s9qzr5xwxat as step,
  arrayCopytctsywo3h7gj as arrayCopy,
  round2mrvepag8eey0 as round,
  toList383f556t1dixk as toList_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  ilog23dbvpk38jf7rc as ilog2,
  umod164hvijxhfi8p as umod,
  ilog2Ceil34a3ub1n8578t as ilog2Ceil,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  appendNice3hizhj9kone09 as appendNice,
  appendGenericArray5krccch8fjd0 as appendGenericArray,
  isAlmostEquals$default1fay4lgiuix8d as isAlmostEquals$default,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  listIterator247sl90ooi4qv as listIterator,
  DoubleList2honu8rif2roh as DoubleList,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  Mixin3lmkm5hum2vdj as Mixin,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  Lock5n7hh3dgcidl as Lock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  isAlmostEquals2qd88bwpjj4z5 as isAlmostEquals,
  IDoubleVectorListoa05cse3he2p as IDoubleVectorList,
  Vector2D378fe5rov8fgw as Vector2D,
  IPointListz7raskb2mrxa as IPointList,
  isNotEmptyrwyeygz7izwg as isNotEmpty,
  containsAll194lepx84fvib as containsAll,
  indexOf3tp8bzbv46hci as indexOf,
  iterator1sm8hwbj0nmg8 as iterator,
  listIteratorrk3szyua4uzm as listIterator_0,
  listIterator3ooh2yjav3kr9 as listIterator_1,
  subList2funs4qwcrhhq as subList,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {}
class IArray2 {}
function inside(x, y) {
  return x >= 0 && y >= 0 && x < this.w9z() && y < this.x9z();
}
function getAt(x, y) {
  return this.ea0(x, y) ? this.j9u(indexOr(this, x, y)) : this.j9u(0);
}
function asString() {
  var tmp = until(0, this.x9z());
  return joinToString(tmp, '\n', VOID, VOID, VOID, VOID, IArray2$asString$lambda(this));
}
class IntIArray2 {}
function get(x, y) {
  return this.z9z(indexOr(this, x, y));
}
function set(x, y, value) {
  return this.aa0(indexOr(this, x, y), value);
}
function getAt_0(idx) {
  return this.z9z(idx);
}
class IntArray2 {
  constructor(width, height, data) {
    this.t9z_1 = width;
    this.u9z_1 = height;
    this.v9z_1 = data;
    Companion_instance_4.y9z(this.w9z(), this.x9z(), this.v9z_1.length);
  }
  w9z() {
    return this.t9z_1;
  }
  x9z() {
    return this.u9z_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof IntArray2) {
      tmp_1 = this.w9z() === other.w9z();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.x9z() === other.x9z();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.v9z_1, other.v9z_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  z9z(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.v9z_1;
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      tmp = this.v9z_1[0];
    }
    return tmp;
  }
  aa0(idx, value) {
    if (0 <= idx ? idx <= (this.v9z_1.length - 1 | 0) : false) {
      this.v9z_1[idx] = value;
    }
  }
  hashCode() {
    return (this.w9z() + this.x9z() | 0) + contentHashCode(this.v9z_1) | 0;
  }
  p1() {
    return intArrayIterator(this.v9z_1);
  }
  toString() {
    return this.ba0();
  }
}
class Companion_0 {}
class FloatIArray2 {}
function get_0(x, y) {
  return this.z9z(indexOr(this, x, y));
}
function set_0(x, y, value) {
  return this.ia0(indexOr(this, x, y), value);
}
function getAt_1(idx) {
  return this.z9z(idx);
}
class FloatArray2 {
  constructor(width, height, data) {
    this.fa0_1 = width;
    this.ga0_1 = height;
    this.ha0_1 = data;
    Companion_instance_4.y9z(this.w9z(), this.x9z(), this.ha0_1.length);
  }
  w9z() {
    return this.fa0_1;
  }
  x9z() {
    return this.ga0_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof FloatArray2) {
      tmp_1 = this.w9z() === other.w9z();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.x9z() === other.x9z();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals_0(this.ha0_1, other.ha0_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  z9z(idx) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.ha0_1;
    var tmp;
    if (0 <= idx ? idx <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[idx];
    } else {
      tmp = 0.0;
    }
    return tmp;
  }
  ia0(idx, value) {
    if (0 <= idx ? idx <= (this.ha0_1.length - 1 | 0) : false) {
      this.ha0_1[idx] = value;
    }
  }
  hashCode() {
    return (this.w9z() + this.x9z() | 0) + contentHashCode_0(this.ha0_1) | 0;
  }
  p1() {
    return floatArrayIterator(this.ha0_1);
  }
  toString() {
    return this.ba0();
  }
}
class ByteArrayDeque {
  constructor(initialBits, allowGrow) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    allowGrow = allowGrow === VOID ? true : allowGrow;
    this.sa0_1 = initialBits;
    this.ta0_1 = allowGrow;
    this.ua0_1 = new RingBuffer(this.sa0_1);
    this.va0_1 = new Int8Array(1024);
    this.wa0_1 = new Long(0, 0);
    this.xa0_1 = new Long(0, 0);
  }
  za0() {
    return this.ua0_1.ra0_1;
  }
  aa1(buffer, offset, size) {
    ensureWrite(this, size);
    var out = this.ua0_1.aa1(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      var this_0 = this.wa0_1;
      tmp.wa0_1 = add(this_0, fromInt(out));
    }
    return out;
  }
  ba1(buffer, offset, size, $super) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? buffer.length - offset | 0 : size;
    return $super === VOID ? this.aa1(buffer, offset, size) : $super.aa1.call(this, buffer, offset, size);
  }
  ca1(count) {
    return this.ua0_1.ca1(count);
  }
  da1(buffer, offset, size) {
    return this.ua0_1.da1(buffer, offset, size);
  }
  a5() {
    this.ua0_1.a5();
  }
  hashCode() {
    return this.ua0_1.ea1();
  }
  equals(other) {
    var tmp;
    if (other instanceof ByteArrayDeque) {
      tmp = this.ua0_1.equals(other.ua0_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class ShortArrayDeque {
  constructor(initialBits) {
    initialBits = initialBits === VOID ? 10 : initialBits;
    this.oa1_1 = initialBits;
    this.pa1_1 = new ShortRingBuffer(this.oa1_1);
    this.qa1_1 = new Int16Array(1024);
    this.ra1_1 = new Long(0, 0);
    this.sa1_1 = new Long(0, 0);
  }
  za0() {
    return this.pa1_1.ma1_1;
  }
  ua1(buffer, offset, size) {
    var out = ensureWrite_0(this, size).pa1_1.ua1(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      var this_0 = this.ra1_1;
      tmp.ra1_1 = add(this_0, fromInt(out));
    }
    return out;
  }
  ta1(buffer, offset, size) {
    var out = this.pa1_1.ta1(buffer, offset, size);
    if (out > 0) {
      var tmp = this;
      // Inline function 'kotlin.Long.plus' call
      var this_0 = this.sa1_1;
      tmp.sa1_1 = add(this_0, fromInt(out));
    }
    return out;
  }
  a5() {
    this.pa1_1.a5();
  }
  va1() {
    this.ta1(this.qa1_1, 0, 1);
    return this.qa1_1[0];
  }
  wa1(value) {
    this.qa1_1[0] = value;
    this.ua1(this.qa1_1, 0, 1);
  }
  hashCode() {
    return this.pa1_1.ea1();
  }
  equals(other) {
    var tmp;
    if (other instanceof ShortArrayDeque) {
      tmp = this.pa1_1.equals(other.pa1_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class Companion_1 {}
class IntArrayList {
  constructor(capacity) {
    return new.target.za1(capacity);
  }
  static za1(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Int32Array(capacity);
    tmp.xa1_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.ya1_1 = 0;
    return $this;
  }
  aa2(value) {
    this.ba2(value);
    this.ya1_1 = value;
  }
  s2() {
    return this.ya1_1;
  }
  static ca2(other) {
    var $this = this.za1();
    $this.da2(other);
    return $this;
  }
  static ea2(other) {
    var $this = this.za1();
    $this.fa2(other);
    return $this;
  }
  ba2(count) {
    if ((this.ya1_1 + count | 0) > this.xa1_1.length) {
      var tmp = this;
      var tmp_0 = this.xa1_1;
      var tmp0 = this.ya1_1 + count | 0;
      // Inline function 'kotlin.math.max' call
      var b = imul(this.xa1_1.length, 3);
      var tmp$ret$0 = Math.max(tmp0, b);
      var tmp_1 = copyOf(tmp_0, tmp$ret$0);
      tmp.xa1_1 = isIntArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  a5() {
    this.ya1_1 = 0;
  }
  ga2(v0) {
    this.ba2(1);
    var tmp = this.xa1_1;
    var _unary__edvuaz = this.ya1_1;
    this.ya1_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  ha2(v0, v1, v2, v3) {
    this.ba2(4);
    var tmp = this.xa1_1;
    var _unary__edvuaz = this.ya1_1;
    this.ya1_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.xa1_1;
    var _unary__edvuaz_0 = this.ya1_1;
    this.ya1_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.xa1_1;
    var _unary__edvuaz_1 = this.ya1_1;
    this.ya1_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.xa1_1;
    var _unary__edvuaz_2 = this.ya1_1;
    this.ya1_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  ia2(v0, v1, v2, v3, v4, v5) {
    this.ba2(6);
    var tmp = this.xa1_1;
    var _unary__edvuaz = this.ya1_1;
    this.ya1_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.xa1_1;
    var _unary__edvuaz_0 = this.ya1_1;
    this.ya1_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.xa1_1;
    var _unary__edvuaz_1 = this.ya1_1;
    this.ya1_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.xa1_1;
    var _unary__edvuaz_2 = this.ya1_1;
    this.ya1_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
    var tmp_3 = this.xa1_1;
    var _unary__edvuaz_3 = this.ya1_1;
    this.ya1_1 = _unary__edvuaz_3 + 1 | 0;
    tmp_3[_unary__edvuaz_3] = v4;
    var tmp_4 = this.xa1_1;
    var _unary__edvuaz_4 = this.ya1_1;
    this.ya1_1 = _unary__edvuaz_4 + 1 | 0;
    tmp_4[_unary__edvuaz_4] = v5;
  }
  ja2(value) {
    return this.ga2(value);
  }
  ka2(value) {
    return this.da2(value);
  }
  la2(values, offset, length) {
    this.ba2(length);
    var tmp = Memory_instance;
    tmp.ma2(isIntArray(values) ? values : THROW_CCE(), offset, this.xa1_1, this.s2(), length);
    this.aa2(this.s2() + length | 0);
  }
  fa2(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.la2(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.la2.call(this, values, offset, length);
    }
    return tmp;
  }
  da2(values) {
    return this.la2(values.xa1_1, 0, values.s2());
  }
  u2(index) {
    return this.xa1_1[index];
  }
  j9u(index) {
    return this.xa1_1[index];
  }
  s7x(index, value) {
    if (index >= this.ya1_1) {
      this.ba2(index + 1 | 0);
      this.ya1_1 = index + 1 | 0;
    }
    this.xa1_1[index] = value;
  }
  p1() {
    return this.x2(0);
  }
  as(element) {
    var inductionVariable = 0;
    var last = this.ya1_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.xa1_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  w2(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.as((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  na2(elements) {
    var _iterator__ex2g4s = elements.p1();
    while (_iterator__ex2g4s.q1()) {
      var e = _iterator__ex2g4s.r1();
      if (!this.as(e))
        return false;
    }
    return true;
  }
  r4(elements) {
    return this.na2(elements);
  }
  n1() {
    return this.s2() === 0;
  }
  o9j() {
    return !(this.s2() === 0);
  }
  vl() {
    var tmp;
    if (this.n1()) {
      throw IndexOutOfBoundsException.ve();
    } else {
      tmp = this.xa1_1[0];
    }
    return tmp;
  }
  oa2() {
    var tmp;
    if (this.n1()) {
      throw IndexOutOfBoundsException.ve();
    } else {
      tmp = this.xa1_1[this.ya1_1 - 1 | 0];
    }
    return tmp;
  }
  pa2(index, value) {
    // Inline function 'kotlin.apply' call
    this.ba2(1);
    if (this.o9j()) {
      Memory_instance.ma2(this.xa1_1, index, this.xa1_1, index + 1 | 0, this.ya1_1 - index | 0);
    }
    this.xa1_1[index] = value;
    this.ya1_1 = this.ya1_1 + 1 | 0;
    return this;
  }
  qa2(indexA, indexB) {
    var l = this.j9u(indexA);
    var r = this.j9u(indexB);
    this.s7x(indexA, r);
    this.s7x(indexB, l);
  }
  g5(index) {
    return this.ra2(index, 1);
  }
  ra2(index, count) {
    if (index < 0 || index >= this.ya1_1 || (index + count | 0) > this.ya1_1)
      throw IndexOutOfBoundsException.ve();
    var out = this.xa1_1[index];
    if (count > 0) {
      if (index < (this.ya1_1 - count | 0)) {
        Memory_instance.ma2(this.xa1_1, index + count | 0, this.xa1_1, index, (this.ya1_1 - index | 0) - count | 0);
      }
      this.ya1_1 = this.ya1_1 - count | 0;
    }
    return out;
  }
  sa2() {
    return copyOf(this.xa1_1, this.ya1_1);
  }
  x2(index) {
    return take(this.xa1_1, this.ya1_1).x2(index);
  }
  hashCode() {
    return contentHashCode_2(this.xa1_1, 0, this.s2());
  }
  equals(other) {
    if (other instanceof IntArrayList)
      return this.s2() === other.s2() && contentEquals_2(this.xa1_1, other.xa1_1, 0, this.s2());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.ad(2 + imul(5, this.s2()) | 0);
    this_0.o1(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.m1(', ');
        }
        this_0.kh(this.j9u(n));
      }
       while (inductionVariable < last);
    this_0.o1(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_2 {}
class FloatArrayList {
  constructor(capacity) {
    return new.target.va2(capacity);
  }
  static va2(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Float32Array(capacity);
    tmp.ta2_1 = isFloatArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.ua2_1 = 0;
    return $this;
  }
  aa2(value) {
    ensure(this, value);
    this.ua2_1 = value;
  }
  s2() {
    return this.ua2_1;
  }
  static wa2(other) {
    var $this = this.va2();
    $this.xa2(other);
    return $this;
  }
  a5() {
    this.ua2_1 = 0;
  }
  ya2(v0, v1, v2, v3) {
    ensure(this, 4);
    var tmp = this.ta2_1;
    var _unary__edvuaz = this.ua2_1;
    this.ua2_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.ta2_1;
    var _unary__edvuaz_0 = this.ua2_1;
    this.ua2_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.ta2_1;
    var _unary__edvuaz_1 = this.ua2_1;
    this.ua2_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.ta2_1;
    var _unary__edvuaz_2 = this.ua2_1;
    this.ua2_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  za2(values, offset, length) {
    ensure(this, length);
    var tmp = Memory_instance;
    tmp.aa3(isFloatArray(values) ? values : THROW_CCE(), offset, this.ta2_1, this.s2(), length);
    this.aa2(this.s2() + length | 0);
  }
  xa2(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.za2(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.za2.call(this, values, offset, length);
    }
    return tmp;
  }
  j9u(index) {
    return this.ta2_1[index];
  }
  p1() {
    return this.x2(0);
  }
  ba3(element) {
    var inductionVariable = 0;
    var last = this.ua2_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.ta2_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  w2(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.ba3((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  ca3(elements) {
    var _iterator__ex2g4s = elements.p1();
    while (_iterator__ex2g4s.q1()) {
      var e = _iterator__ex2g4s.r1();
      if (!this.ba3(e))
        return false;
    }
    return true;
  }
  r4(elements) {
    return this.ca3(elements);
  }
  n1() {
    return this.s2() === 0;
  }
  da3() {
    return copyOf_0(this.ta2_1, this.ua2_1);
  }
  x2(index) {
    return take_0(this.ta2_1, this.ua2_1).x2(index);
  }
  hashCode() {
    return contentHashCode_3(this.ta2_1, 0, this.s2());
  }
  equals(other) {
    if (other instanceof FloatArrayList)
      return this.s2() === other.s2() && contentEquals_3(this.ta2_1, other.ta2_1, 0, this.s2());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.ad(2 + imul(5, this.s2()) | 0);
    this_0.o1(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.m1(', ');
        }
        this_0.mh(this.j9u(n));
      }
       while (inductionVariable < last);
    this_0.o1(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class Companion_3 {}
class DoubleArrayList {
  constructor(capacity) {
    return new.target.ga3(capacity);
  }
  static ga3(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var $this = createThis(this);
    var tmp = $this;
    var tmp_0 = new Float64Array(capacity);
    tmp.ea3_1 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.fa3_1 = 0;
    return $this;
  }
  aa2(value) {
    ensure_0(this, value);
    this.fa3_1 = value;
  }
  s2() {
    return this.fa3_1;
  }
  static ha3(other) {
    var $this = this.ga3();
    $this.ia3(other);
    return $this;
  }
  static ja3(other) {
    var $this = this.ga3();
    $this.ka3(other);
    return $this;
  }
  a5() {
    this.fa3_1 = 0;
  }
  la3(v0) {
    ensure_0(this, 1);
    var tmp = this.ea3_1;
    var _unary__edvuaz = this.fa3_1;
    this.fa3_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
  }
  ma3(v0, v1) {
    ensure_0(this, 2);
    var tmp = this.ea3_1;
    var _unary__edvuaz = this.fa3_1;
    this.fa3_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.ea3_1;
    var _unary__edvuaz_0 = this.fa3_1;
    this.fa3_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
  }
  na3(v0, v1, v2, v3) {
    ensure_0(this, 4);
    var tmp = this.ea3_1;
    var _unary__edvuaz = this.fa3_1;
    this.fa3_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.ea3_1;
    var _unary__edvuaz_0 = this.fa3_1;
    this.fa3_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.ea3_1;
    var _unary__edvuaz_1 = this.fa3_1;
    this.fa3_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.ea3_1;
    var _unary__edvuaz_2 = this.fa3_1;
    this.fa3_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
  }
  oa3(v0, v1, v2, v3, v4, v5) {
    ensure_0(this, 6);
    var tmp = this.ea3_1;
    var _unary__edvuaz = this.fa3_1;
    this.fa3_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = v0;
    var tmp_0 = this.ea3_1;
    var _unary__edvuaz_0 = this.fa3_1;
    this.fa3_1 = _unary__edvuaz_0 + 1 | 0;
    tmp_0[_unary__edvuaz_0] = v1;
    var tmp_1 = this.ea3_1;
    var _unary__edvuaz_1 = this.fa3_1;
    this.fa3_1 = _unary__edvuaz_1 + 1 | 0;
    tmp_1[_unary__edvuaz_1] = v2;
    var tmp_2 = this.ea3_1;
    var _unary__edvuaz_2 = this.fa3_1;
    this.fa3_1 = _unary__edvuaz_2 + 1 | 0;
    tmp_2[_unary__edvuaz_2] = v3;
    var tmp_3 = this.ea3_1;
    var _unary__edvuaz_3 = this.fa3_1;
    this.fa3_1 = _unary__edvuaz_3 + 1 | 0;
    tmp_3[_unary__edvuaz_3] = v4;
    var tmp_4 = this.ea3_1;
    var _unary__edvuaz_4 = this.fa3_1;
    this.fa3_1 = _unary__edvuaz_4 + 1 | 0;
    tmp_4[_unary__edvuaz_4] = v5;
  }
  pa3(value) {
    return this.la3(value);
  }
  qa3(value) {
    return this.ia3(value);
  }
  ra3(values, offset, length) {
    ensure_0(this, length);
    var tmp = Memory_instance;
    tmp.sa3(isDoubleArray(values) ? values : THROW_CCE(), offset, this.ea3_1, this.s2(), length);
    this.aa2(this.s2() + length | 0);
  }
  ka3(values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.ra3(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.ra3.call(this, values, offset, length);
    }
    return tmp;
  }
  ia3(values) {
    return this.ra3(values.ea3_1, 0, values.s2());
  }
  u2(index) {
    return this.ea3_1[index];
  }
  j9u(index) {
    return this.ea3_1[index];
  }
  ta3(index, value) {
    if (index >= this.fa3_1) {
      ensure_0(this, index + 1 | 0);
      this.fa3_1 = index + 1 | 0;
    }
    this.ea3_1[index] = value;
  }
  p1() {
    return this.x2(0);
  }
  l9u(element) {
    var inductionVariable = 0;
    var last = this.fa3_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.ea3_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  }
  w2(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.l9u((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  m9u(elements) {
    var _iterator__ex2g4s = elements.p1();
    while (_iterator__ex2g4s.q1()) {
      var e = _iterator__ex2g4s.r1();
      if (!this.l9u(e))
        return false;
    }
    return true;
  }
  r4(elements) {
    return this.m9u(elements);
  }
  n1() {
    return this.s2() === 0;
  }
  qa2(indexA, indexB) {
    var l = this.j9u(indexA);
    var r = this.j9u(indexB);
    this.ta3(indexA, r);
    this.ta3(indexB, l);
  }
  g5(index) {
    return this.ra2(index, 1);
  }
  ra2(index, count) {
    if (index < 0 || index >= this.fa3_1 || (index + count | 0) > this.fa3_1)
      throw IndexOutOfBoundsException.ve();
    var out = this.ea3_1[index];
    if (count > 0) {
      if (index < (this.fa3_1 - count | 0)) {
        Memory_instance.sa3(this.ea3_1, index + count | 0, this.ea3_1, index, (this.fa3_1 - index | 0) - count | 0);
      }
      this.fa3_1 = this.fa3_1 - count | 0;
    }
    return out;
  }
  k9u() {
    return copyOf_1(this.ea3_1, this.fa3_1);
  }
  x2(index) {
    return take_1(this.ea3_1, this.fa3_1).x2(index);
  }
  t4(fromIndex, toIndex) {
    // Inline function 'kotlin.collections.asList' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.ea3_1;
    return asList(tmp$ret$1).t4(fromIndex, toIndex);
  }
  g9m() {
    return DoubleArrayList.ha3(this);
  }
  hashCode() {
    return contentHashCode_4(this.ea3_1, 0, this.s2());
  }
  equals(other) {
    if (other instanceof DoubleArrayList)
      return this.s2() === other.s2() && contentEquals_4(this.ea3_1, other.ea3_1, 0, this.s2());
    if (!(other == null) ? isInterface(other, KtList) : false)
      return equals(other, this);
    return false;
  }
  toString() {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder.ad(2 + imul(5, this.s2()) | 0);
    this_0.o1(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.m1(', ');
        }
        this_0.nh(this.j9u(n));
      }
       while (inductionVariable < last);
    this_0.o1(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  }
}
class SortOps {
  za3(subject, indexL, indexR) {
    var inductionVariable = indexR;
    var last = indexL + 1 | 0;
    if (last <= inductionVariable)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.ya3(subject, n - 1 | 0, n);
      }
       while (!(n === last));
  }
  ua3(subject, indexL, indexR) {
    var count = (indexR - indexL | 0) + 1 | 0;
    var inductionVariable = 0;
    var last = count / 2 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.ya3(subject, indexL + n | 0, indexR - n | 0);
      }
       while (inductionVariable < last);
  }
}
class DoubleArrayListSortOps extends SortOps {
  constructor() {
    DoubleArrayListSortOps_instance = null;
    super();
    DoubleArrayListSortOps_instance = this;
  }
  va3(subject, l, r) {
    return compareTo(subject.j9u(l), subject.j9u(r));
  }
  wa3(subject, l, r) {
    return this.va3(subject instanceof DoubleArrayList ? subject : THROW_CCE(), l, r);
  }
  xa3(subject, indexL, indexR) {
    var l = subject.j9u(indexL);
    var r = subject.j9u(indexR);
    subject.ta3(indexR, l);
    subject.ta3(indexL, r);
  }
  ya3(subject, indexL, indexR) {
    return this.xa3(subject instanceof DoubleArrayList ? subject : THROW_CCE(), indexL, indexR);
  }
}
class TGenDeque$iterator$1 {
  constructor($that, this$0) {
    this.fa4_1 = $that;
    this.ga4_1 = this$0;
    this.ea4_1 = 0;
  }
  r1() {
    var _unary__edvuaz = this.ea4_1;
    this.ea4_1 = _unary__edvuaz + 1 | 0;
    return this.fa4_1.u2(_unary__edvuaz);
  }
  q1() {
    return this.ea4_1 < this.ga4_1.s2();
  }
  s7() {
    this.ea4_1 = this.ea4_1 - 1 | 0;
    this.ga4_1.g5(this.ea4_1);
  }
}
class TGenDeque {
  constructor(initialCapacity) {
    return new.target.ha4(initialCapacity);
  }
  static ha4(initialCapacity) {
    var $this = createThis(this);
    $this.aa4_1 = 0;
    $this.ba4_1 = 0;
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(initialCapacity);
    tmp.ca4_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static ia4() {
    return this.ha4(16);
  }
  s2() {
    return this.ba4_1;
  }
  n1() {
    return this.s2() === 0;
  }
  ja4(item) {
    resizeIfRequiredFor(this, 1);
    _addLast(this, item);
  }
  ka4(list) {
    // Inline function 'korlibs.datastructure.TGenDeque._addAll' call
    var count = list.s2();
    resizeIfRequiredFor(this, count);
    var base = this.aa4_1 + this.ba4_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.ca4_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3(this) | 0;
        tmp[tmp_0] = list.u2(n);
      }
       while (inductionVariable < count);
    this.ba4_1 = this.ba4_1 + count | 0;
    return true;
  }
  la4(elements) {
    return this.ka4(toList(elements));
  }
  t2(elements) {
    return this.la4(elements);
  }
  zl() {
    if (this.ba4_1 <= 0)
      throw IndexOutOfBoundsException.ve();
    var out = this.ma4();
    nullify(this, this.aa4_1);
    this.aa4_1 = (this.aa4_1 + 1 | 0) % _get_capacity__a9k9f3(this) | 0;
    this.ba4_1 = this.ba4_1 - 1 | 0;
    return out;
  }
  bm() {
    if (this.ba4_1 <= 0)
      throw IndexOutOfBoundsException.ve();
    var out = this.na4();
    nullify(this, internalIndex(this, this.s2() - 1 | 0));
    this.ba4_1 = this.ba4_1 - 1 | 0;
    return out;
  }
  g5(index) {
    if (index < 0 || index >= this.s2())
      throw IndexOutOfBoundsException.ve();
    if (index === 0)
      return this.zl();
    if (index === (this.s2() - 1 | 0))
      return this.bm();
    var old = this.u2(index);
    if (index < (this.s2() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.oa4(n, this.u2(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.aa4_1 = umod(this.aa4_1 + 1 | 0, _get_capacity__a9k9f3(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.s2() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.oa4(n_0, this.u2(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.ba4_1 = this.ba4_1 - 1 | 0;
    return old;
  }
  pa4(element) {
    // Inline function 'kotlin.apply' call
    this.ja4(element);
    return true;
  }
  d2(element) {
    return this.pa4(element);
  }
  qa4(element) {
    var index = this.ra4(element);
    if (index >= 0) {
      this.g5(index);
    }
    return index >= 0;
  }
  z4(element) {
    if (!true)
      return false;
    return this.qa4(element);
  }
  ma4() {
    return this.ca4_1[this.aa4_1];
  }
  na4() {
    return this.ca4_1[internalIndex(this, this.s2() - 1 | 0)];
  }
  oa4(index, value) {
    this.ca4_1[internalIndex(this, index)] = value;
  }
  u2(index) {
    return this.ca4_1[internalIndex(this, index)];
  }
  sa4(index) {
    return (0 <= index ? index <= (this.s2() - 1 | 0) : false) ? this.u2(index) : null;
  }
  ta4(element) {
    var tmp0 = until(0, this.s2());
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = tmp0.n3_1;
      var last = tmp0.o3_1;
      if (inductionVariable <= last)
        do {
          var element_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = element_0;
          if (equals(this.u2(it), element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element_0 === last));
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  w2(element) {
    if (!true)
      return false;
    return this.ta4(element);
  }
  ra4(element) {
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.u2(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  ua4(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = to(item, 0);
      destination.d2(tmp$ret$2);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.u2(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).u4(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.b5(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp0 = emap.y4();
    var tmp$ret$6;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$6 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = tmp0.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element = _iterator__ex2g4s_0.r1();
        if (!(element === 1)) {
          tmp$ret$6 = false;
          break $l$block_0;
        }
      }
      tmp$ret$6 = true;
    }
    return tmp$ret$6;
  }
  r4(elements) {
    return this.ua4(elements);
  }
  p1() {
    var that = this;
    return new TGenDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.s2();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.u2(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof TGenDeque))
      return false;
    if (!(other.s2() === this.s2()))
      return false;
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(this.u2(n), other.u2(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.l1();
    sb.o1(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.s1(this.u2(n));
        if (!(n === (this.s2() - 1 | 0))) {
          sb.m1(', ');
        }
      }
       while (inductionVariable < last);
    sb.o1(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class IntDeque$iterator$1 {
  constructor($that, this$0) {
    this.za4_1 = $that;
    this.aa5_1 = this$0;
    this.ya4_1 = 0;
  }
  r1() {
    var _unary__edvuaz = this.ya4_1;
    this.ya4_1 = _unary__edvuaz + 1 | 0;
    return this.za4_1.u2(_unary__edvuaz);
  }
  q1() {
    return this.ya4_1 < this.aa5_1.s2();
  }
  s7() {
    this.ya4_1 = this.ya4_1 - 1 | 0;
    this.aa5_1.g5(this.ya4_1);
  }
}
class IntDeque {
  constructor(initialCapacity) {
    return new.target.ba5(initialCapacity);
  }
  static ba5(initialCapacity) {
    var $this = createThis(this);
    $this.va4_1 = 0;
    $this.wa4_1 = 0;
    var tmp = $this;
    var tmp_0 = new Int32Array(initialCapacity);
    tmp.xa4_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    return $this;
  }
  static ca5() {
    return this.ba5(16);
  }
  s2() {
    return this.wa4_1;
  }
  n1() {
    return this.s2() === 0;
  }
  da5(item) {
    resizeIfRequiredFor_0(this, 1);
    _addLast_0(this, item);
  }
  ea5(list) {
    // Inline function 'korlibs.datastructure.IntDeque._addAll' call
    var count = list.s2();
    resizeIfRequiredFor_0(this, count);
    var base = this.va4_1 + this.wa4_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.xa4_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3_0(this) | 0;
        tmp[tmp_0] = list.u2(n);
      }
       while (inductionVariable < count);
    this.wa4_1 = this.wa4_1 + count | 0;
    return true;
  }
  fa5(elements) {
    return this.ea5(toList(elements));
  }
  t2(elements) {
    return this.fa5(elements);
  }
  zl() {
    if (this.wa4_1 <= 0)
      throw IndexOutOfBoundsException.ve();
    var out = this.ma4();
    nullify_0(this, this.va4_1);
    this.va4_1 = (this.va4_1 + 1 | 0) % _get_capacity__a9k9f3_0(this) | 0;
    this.wa4_1 = this.wa4_1 - 1 | 0;
    return out;
  }
  bm() {
    if (this.wa4_1 <= 0)
      throw IndexOutOfBoundsException.ve();
    var out = this.na4();
    nullify_0(this, internalIndex_0(this, this.s2() - 1 | 0));
    this.wa4_1 = this.wa4_1 - 1 | 0;
    return out;
  }
  g5(index) {
    if (index < 0 || index >= this.s2())
      throw IndexOutOfBoundsException.ve();
    if (index === 0)
      return this.zl();
    if (index === (this.s2() - 1 | 0))
      return this.bm();
    var old = this.u2(index);
    if (index < (this.s2() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.s7x(n, this.u2(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.va4_1 = umod(this.va4_1 + 1 | 0, _get_capacity__a9k9f3_0(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.s2() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.s7x(n_0, this.u2(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.wa4_1 = this.wa4_1 - 1 | 0;
    return old;
  }
  ga5(element) {
    // Inline function 'kotlin.apply' call
    this.da5(element);
    return true;
  }
  d2(element) {
    return this.ga5((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  ha5(element) {
    var index = this.ia5(element);
    if (index >= 0) {
      this.g5(index);
    }
    return index >= 0;
  }
  z4(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.ha5((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  ma4() {
    return this.xa4_1[this.va4_1];
  }
  na4() {
    return this.xa4_1[internalIndex_0(this, this.s2() - 1 | 0)];
  }
  s7x(index, value) {
    this.xa4_1[internalIndex_0(this, index)] = value;
  }
  u2(index) {
    return this.xa4_1[internalIndex_0(this, index)];
  }
  as(element) {
    var tmp0 = until(0, this.s2());
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = tmp0.n3_1;
      var last = tmp0.o3_1;
      if (inductionVariable <= last)
        do {
          var element_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = element_0;
          if (this.u2(it) === element) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element_0 === last));
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  w2(element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.as((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  }
  ia5(element) {
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.u2(n) === element)
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  na2(elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(elements, 10));
    var _iterator__ex2g4s = elements.p1();
    while (_iterator__ex2g4s.q1()) {
      var item = _iterator__ex2g4s.r1();
      var tmp$ret$2 = to(item, 0);
      destination.d2(tmp$ret$2);
    }
    var emap = toLinkedMap(destination);
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.u2(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, KtMap) ? emap : THROW_CCE()).u4(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.b5(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp0 = emap.y4();
    var tmp$ret$6;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$6 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = tmp0.p1();
      while (_iterator__ex2g4s_0.q1()) {
        var element = _iterator__ex2g4s_0.r1();
        if (!(element === 1)) {
          tmp$ret$6 = false;
          break $l$block_0;
        }
      }
      tmp$ret$6 = true;
    }
    return tmp$ret$6;
  }
  r4(elements) {
    return this.na2(elements);
  }
  p1() {
    var that = this;
    return new IntDeque$iterator$1(that, this);
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.s2();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.u2(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  }
  equals(other) {
    if (!(other instanceof IntDeque))
      return false;
    if (!(other.s2() === this.s2()))
      return false;
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.u2(n) === other.u2(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  }
  toString() {
    var sb = StringBuilder.l1();
    sb.o1(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.kh(this.u2(n));
        if (!(n === (this.s2() - 1 | 0))) {
          sb.m1(', ');
        }
      }
       while (inductionVariable < last);
    sb.o1(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
class FastSmallSet extends AbstractMutableSet {
  constructor() {
    return new.target.na5();
  }
  static na5() {
    var $this = this.c9();
    $this.ja5_1 = LinkedHashSet.v2();
    $this.ka5_1 = null;
    $this.la5_1 = null;
    $this.ma5_1 = null;
    return $this;
  }
  s2() {
    return this.ja5_1.s2();
  }
  p1() {
    return this.ja5_1.p1();
  }
  oa5(element) {
    if (this.pa5(element))
      return false;
    this.ja5_1.d2(element);
    return true;
  }
  d2(element) {
    return this.oa5(element);
  }
  qa5(element) {
    this.ka5_1 = null;
    this.la5_1 = null;
    this.ma5_1 = null;
    this.ja5_1.z4(element);
    return true;
  }
  z4(element) {
    if (!true)
      return false;
    return this.qa5(element);
  }
  pa5(element) {
    if (element === this.ka5_1 || element === this.la5_1 || element === this.ka5_1)
      return true;
    var result = this.ja5_1.w2(element);
    if (result) {
      this.la5_1 = this.ka5_1;
      this.ma5_1 = this.la5_1;
      this.ka5_1 = element;
    }
    return result;
  }
  w2(element) {
    if (!true)
      return false;
    return this.pa5(element);
  }
  a5() {
    this.ja5_1.a5();
    this.ka5_1 = null;
    this.la5_1 = null;
    this.ma5_1 = null;
  }
}
class GenericSubList {
  constructor(base, start, end) {
    this.ra5_1 = base;
    this.sa5_1 = start;
    this.ta5_1 = end;
    var containsUpper = this.ra5_1.s2();
    var containsArg = this.sa5_1;
    if (!(0 <= containsArg ? containsArg <= containsUpper : false))
      throw IndexOutOfBoundsException.h3('' + this.sa5_1);
    var containsUpper_0 = this.ra5_1.s2();
    var containsArg_0 = this.ta5_1;
    if (!(0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false))
      throw IndexOutOfBoundsException.h3('' + this.ta5_1);
  }
  s2() {
    return this.ta5_1 - this.sa5_1 | 0;
  }
  pa5(element) {
    var tmp0 = until(0, this.s2());
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = tmp0.n3_1;
      var last = tmp0.o3_1;
      if (inductionVariable <= last)
        do {
          var element_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = element_0;
          if (equals(this.u2(it), element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element_0 === last));
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  w2(element) {
    if (!true)
      return false;
    return this.pa5(element);
  }
  ua5(elements) {
    var elementsSet = toMutableSet(elements);
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.minusAssign' call
        var element = this.u2(n);
        elementsSet.z4(element);
      }
       while (inductionVariable < last);
    return elementsSet.n1();
  }
  r4(elements) {
    return this.ua5(elements);
  }
  u2(index) {
    return this.ra5_1.u2(translateIndex(this, index));
  }
  va5(element) {
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.u2(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  y2(element) {
    if (!true)
      return -1;
    return this.va5(element);
  }
  n1() {
    return this.s2() === 0;
  }
  p1() {
    return new GenericListIterator(this);
  }
  s4() {
    return new GenericListIterator(this);
  }
  x2(index) {
    return new GenericListIterator(this, index);
  }
  t4(fromIndex, toIndex) {
    return new GenericSubList(this, fromIndex, toIndex);
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.s2());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.n3_1;
    var last = this_0.o3_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = item;
        var tmp$ret$2 = this.u2(it);
        destination.d2(tmp$ret$2);
      }
       while (!(item === last));
    return toString(destination);
  }
  equals(other) {
    var tmp;
    if (other instanceof GenericSubList) {
      var tmp0 = this.s2();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var inductionVariable = 0;
        if (inductionVariable < tmp0)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!equals(this.u2(n), other.u2(n))) {
              tmp$ret$0 = false;
              break $l$block;
            }
          }
           while (inductionVariable < tmp0);
        tmp$ret$0 = true;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.s2();
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.u2(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class GenericListIterator {
  constructor(list, iindex) {
    iindex = iindex === VOID ? 0 : iindex;
    this.wa5_1 = list;
    this.xa5_1 = iindex;
    var containsUpper = this.wa5_1.s2();
    var containsArg = this.xa5_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      throw IndexOutOfBoundsException.h3('' + this.xa5_1);
    this.ya5_1 = this.xa5_1;
  }
  q1() {
    return this.ya5_1 < this.wa5_1.s2();
  }
  r1() {
    if (!this.q1())
      throw NoSuchElementException.w7();
    var _unary__edvuaz = this.ya5_1;
    this.ya5_1 = _unary__edvuaz + 1 | 0;
    return this.wa5_1.u2(_unary__edvuaz);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof GenericListIterator) {
      tmp_0 = equals(this.wa5_1, other.wa5_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.ya5_1 === other.ya5_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.wa5_1) + this.ya5_1 | 0;
  }
}
class HistoryStack {
  constructor(maxLength, initialCapacity) {
    maxLength = maxLength === VOID ? 2147483637 : maxLength;
    initialCapacity = initialCapacity === VOID ? 7 : initialCapacity;
    this.za5_1 = maxLength;
    this.aa6_1 = TGenDeque.ha4(initialCapacity);
    this.ba6_1 = 0;
  }
  ca6(value) {
    $l$loop: while (true) {
      var tmp;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.aa6_1.n1()) {
        tmp = this.aa6_1.s2() > this.ba6_1;
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      this.aa6_1.bm();
    }
    this.aa6_1.pa4(value);
    this.ba6_1 = this.aa6_1.s2();
    $l$loop_0: while (true) {
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!this.aa6_1.n1()) {
        tmp_0 = this.aa6_1.s2() > this.za5_1;
      } else {
        tmp_0 = false;
      }
      if (!tmp_0) {
        break $l$loop_0;
      }
      this.aa6_1.zl();
      this.ba6_1 = this.ba6_1 - 1 | 0;
    }
  }
  da6() {
    this.ba6_1 = coerceAtLeast(this.ba6_1 - 1 | 0, 0);
    return this.aa6_1.sa4(this.ba6_1 - 1 | 0);
  }
  ea6() {
    // Inline function 'kotlin.also' call
    var this_0 = this.aa6_1.sa4(this.ba6_1);
    this.ba6_1 = coerceAtMost(this.ba6_1 + 1 | 0, this.aa6_1.s2() + 1 | 0);
    return this_0;
  }
}
class Companion_4 {
  y9z(width, height, arraySize) {
    // Inline function 'kotlin.check' call
    if (!(arraySize >= imul(width, height))) {
      var message = 'backing array of size=' + arraySize + ', has less elements than ' + width + ' * ' + height;
      throw IllegalStateException.o(toString(message));
    }
  }
}
class Companion_5 {
  constructor() {
    this.va6_1 = 2147483646;
    this.wa6_1 = 2147483647;
    this.xa6_1 = 0;
  }
}
class Entry {
  constructor(key, value) {
    this.ba7_1 = key;
    this.ca7_1 = value;
  }
  toString() {
    return 'Entry(key=' + this.ba7_1 + ', value=' + toString_0(this.ca7_1) + ')';
  }
  hashCode() {
    var result = this.ba7_1;
    result = imul(result, 31) + (this.ca7_1 == null ? 0 : hashCode(this.ca7_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!(this.ba7_1 === tmp0_other_with_cast.ba7_1))
      return false;
    if (!equals(this.ca7_1, tmp0_other_with_cast.ca7_1))
      return false;
    return true;
  }
}
class Iterator {
  constructor(map) {
    this.fa6_1 = map;
    this.ga6_1 = this.fa6_1.la6_1 ? 2147483647 : nextNonEmptyIndex(this, this.fa6_1.pa6_1, 0);
    this.ha6_1 = new Entry(0, null);
  }
  q1() {
    return !(this.ga6_1 === 2147483646);
  }
  ta6() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentKey(this);
    next(this);
    return this_0;
  }
  ua6() {
    // Inline function 'kotlin.apply' call
    var this_0 = currentValue(this);
    next(this);
    return this_0;
  }
}
class IntMap$keys$$inlined$Iterable$1 {
  constructor(this$0) {
    this.da7_1 = this$0;
  }
  p1() {
    // Inline function 'kotlin.let' call
    var it = new Iterator(this.da7_1);
    var tmp = IntMap$_get_keys_$o$iterator$lambda_bn8atq(it);
    return Iterator_0(tmp, IntMap$_get_keys_$o$iterator$lambda_bn8atq_0(it));
  }
}
class IntMap$values$$inlined$Iterable$1 {
  constructor(this$0) {
    this.ea7_1 = this$0;
  }
  p1() {
    // Inline function 'kotlin.let' call
    var it = new Iterator(this.ea7_1);
    var tmp = IntMap$_get_values_$o$iterator$lambda_ggo058(it);
    return Iterator_0(tmp, IntMap$_get_values_$o$iterator$lambda_ggo058_0(it));
  }
}
class IntMap {
  constructor(nbits, loadFactor, dummy) {
    return new.target.ya6(nbits, loadFactor, dummy);
  }
  static ya6(nbits, loadFactor, dummy) {
    dummy = dummy === VOID ? false : dummy;
    var $this = createThis(this);
    $this.ia6_1 = nbits;
    $this.ja6_1 = loadFactor;
    $this.ka6_1 = 1 << $this.ia6_1;
    $this.la6_1 = false;
    $this.ma6_1 = null;
    $this.na6_1 = $this.ka6_1 - 1 | 0;
    $this.oa6_1 = 1 + imul($this.ia6_1, $this.ia6_1) | 0;
    $this.pa6_1 = new Int32Array($this.aa7());
    var tmp = $this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = $this.aa7();
    var tmp_0 = Array(size);
    tmp.qa6_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    $this.ra6_1 = numberToInt($this.ka6_1 * $this.ja6_1);
    $this.sa6_1 = 0;
    return $this;
  }
  static fa7(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.ya6(tmp$ret$0, loadFactor, true);
  }
  aa7() {
    return this.ka6_1 + this.oa6_1 | 0;
  }
  u2(key) {
    var index = _getKeyIndex(this, key);
    if (index < 0)
      return null;
    if (index === 2147483647)
      return this.ma6_1;
    return this.qa6_1[index];
  }
  za6(key, value) {
    retry: while (true) {
      var index = _getKeyIndex(this, key);
      if (index < 0) {
        if (key === 0) {
          this.la6_1 = true;
          this.ma6_1 = value;
          this.sa6_1 = this.sa6_1 + 1 | 0;
          return null;
        }
        if (this.sa6_1 >= this.ra6_1) {
          grow(this);
        }
        var index1 = hash1(this, key);
        if (this.pa6_1[index1] === 0)
          return setEmptySlot(this, index1, key, value);
        var index2 = hash2(this, key);
        if (this.pa6_1[index2] === 0)
          return setEmptySlot(this, index2, key, value);
        var index3 = hash3(this, key);
        if (this.pa6_1[index3] === 0)
          return setEmptySlot(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu(this);
        var last = this.pa6_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.pa6_1[n] === 0)
              return setEmptySlot(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.oa6_1 > 512) {
          grow(this);
        } else {
          growStash(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.ma6_1;
        this.ma6_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.qa6_1[index];
        this.qa6_1[index] = value;
        return this_1;
      }
    }
  }
  x4() {
    // Inline function 'kotlin.collections.Iterable' call
    return new IntMap$keys$$inlined$Iterable$1(this);
  }
  y4() {
    // Inline function 'kotlin.collections.Iterable' call
    return new IntMap$values$$inlined$Iterable$1(this);
  }
  ga7(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.la6_1 ? 2147483647 : this.ga7(this.pa6_1, 0);
    while (!(index === 2147483646)) {
      var tmp0;
      switch (index) {
        case 2147483647:
        case 2147483646:
          tmp0 = 0;
          break;
        default:
          tmp0 = this.pa6_1[index];
          break;
      }
      var it = tmp0;
      var value = this.u2(it);
      if (!equals(other.u2(it), value))
        return false;
      index = this.ga7(this.pa6_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.la6_1 ? 2147483647 : this.ga7(this.pa6_1, 0);
    while (!(index === 2147483646)) {
      var tmp0;
      switch (index) {
        case 2147483647:
        case 2147483646:
          tmp0 = 0;
          break;
        default:
          tmp0 = this.pa6_1[index];
          break;
      }
      var it = tmp0;
      var tmp = out;
      var tmp_0 = it;
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = this.u2(it);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      out = tmp + (tmp_0 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0) | 0;
      index = this.ga7(this.pa6_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Companion_6 {
  constructor() {
    this.ha7_1 = 2147483646;
    this.ia7_1 = 2147483647;
    this.ja7_1 = 0;
  }
}
class IntIntMap {
  constructor(nbits, loadFactor, dummy) {
    return new.target.va7(nbits, loadFactor, dummy);
  }
  static va7(nbits, loadFactor, dummy) {
    var $this = createThis(this);
    $this.ka7_1 = nbits;
    $this.la7_1 = loadFactor;
    $this.ma7_1 = 1 << $this.ka7_1;
    $this.na7_1 = false;
    $this.oa7_1 = 0;
    $this.pa7_1 = $this.ma7_1 - 1 | 0;
    $this.qa7_1 = 1 + imul($this.ka7_1, $this.ka7_1) | 0;
    $this.ra7_1 = new Int32Array($this.aa7());
    $this.sa7_1 = new Int32Array($this.aa7());
    $this.ta7_1 = numberToInt($this.ma7_1 * $this.la7_1);
    $this.ua7_1 = 0;
    return $this;
  }
  static xa7(initialCapacity, loadFactor) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = ilog2Ceil(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    return this.va7(tmp$ret$0, loadFactor, true);
  }
  toString() {
    return toString(this.ya7());
  }
  aa7() {
    return this.ma7_1 + this.qa7_1 | 0;
  }
  za7(out) {
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.na7_1 ? 2147483647 : this.ga7(this.ra7_1, 0);
    while (!(index === 2147483646)) {
      var tmp0;
      switch (index) {
        case 2147483647:
        case 2147483646:
          tmp0 = 0;
          break;
        default:
          tmp0 = this.ra7_1[index];
          break;
      }
      var it = tmp0;
      // Inline function 'kotlin.collections.set' call
      var value = this.u2(it);
      out.b5(it, value);
      index = this.ga7(this.ra7_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
  ya7(out, $super) {
    out = out === VOID ? linkedHashMapOf([]) : out;
    return $super === VOID ? this.za7(out) : $super.za7.call(this, out);
  }
  as(key) {
    return _getKeyIndex_0(this, key) >= 0;
  }
  a5() {
    this.na7_1 = false;
    this.oa7_1 = 0;
    fill(this.ra7_1, 0);
    fill(this.sa7_1, 0);
    this.ua7_1 = 0;
  }
  u2(key) {
    var index = _getKeyIndex_0(this, key);
    if (index < 0)
      return 0;
    if (index === 2147483647)
      return this.oa7_1;
    return this.sa7_1[index];
  }
  wa7(key, value) {
    retry: while (true) {
      var index = _getKeyIndex_0(this, key);
      if (index < 0) {
        if (key === 0) {
          this.na7_1 = true;
          this.oa7_1 = value;
          this.ua7_1 = this.ua7_1 + 1 | 0;
          return 0;
        }
        if (this.ua7_1 >= this.ta7_1) {
          grow_0(this);
        }
        var index1 = hash1_0(this, key);
        if (this.ra7_1[index1] === 0)
          return setEmptySlot_0(this, index1, key, value);
        var index2 = hash2_0(this, key);
        if (this.ra7_1[index2] === 0)
          return setEmptySlot_0(this, index2, key, value);
        var index3 = hash3_0(this, key);
        if (this.ra7_1[index3] === 0)
          return setEmptySlot_0(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu_0(this);
        var last = this.ra7_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.ra7_1[n] === 0)
              return setEmptySlot_0(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.qa7_1 > 512) {
          grow_0(this);
        } else {
          growStash_0(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.oa7_1;
        this.oa7_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.sa7_1[index];
        this.sa7_1[index] = value;
        return this_1;
      }
    }
  }
  ga7(keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  equals(other) {
    if (!(other instanceof IntIntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.na7_1 ? 2147483647 : this.ga7(this.ra7_1, 0);
    while (!(index === 2147483646)) {
      var tmp0;
      switch (index) {
        case 2147483647:
        case 2147483646:
          tmp0 = 0;
          break;
        default:
          tmp0 = this.ra7_1[index];
          break;
      }
      var it = tmp0;
      var value = this.u2(it);
      if (!(other.u2(it) === value))
        return false;
      index = this.ga7(this.ra7_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  }
  hashCode() {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.na7_1 ? 2147483647 : this.ga7(this.ra7_1, 0);
    while (!(index === 2147483646)) {
      var tmp0;
      switch (index) {
        case 2147483647:
        case 2147483646:
          tmp0 = 0;
          break;
        default:
          tmp0 = this.ra7_1[index];
          break;
      }
      var it = tmp0;
      out = out + (it + this.u2(it) | 0) | 0;
      index = this.ga7(this.ra7_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  }
}
class Iterator$1 {
  constructor($hasNext, $next) {
    this.aa8_1 = $hasNext;
    this.ba8_1 = $next;
  }
  q1() {
    return this.aa8_1();
  }
  r1() {
    return this.ba8_1();
  }
}
class Companion_7 {}
class Pool {
  constructor(reset, preallocate, gen) {
    return new.target.ga8(reset, preallocate, gen);
  }
  static ga8(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = Pool$_init_$lambda_q3cbhr;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = createThis(this);
    $this.ca8_1 = reset;
    $this.da8_1 = gen;
    $this.ea8_1 = _TGenStack___init__impl__yynjgt();
    $this.fa8_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < preallocate)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = $this.fa8_1;
        $this.fa8_1 = _unary__edvuaz + 1 | 0;
        TGenStack__push_impl_9yh33t($this.ea8_1, $this.da8_1(_unary__edvuaz));
      }
       while (inductionVariable < preallocate);
    return $this;
  }
  static ha8(preallocate, gen) {
    preallocate = preallocate === VOID ? 0 : preallocate;
    return this.ga8(Pool$_init_$lambda_q3cbhr_0, preallocate, gen);
  }
  ia8() {
    return _TGenStack___get_size__impl__cvg66t(this.ea8_1);
  }
  ja8() {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(new TGenStack(this.ea8_1)).n1()) {
      tmp = TGenStack__pop_impl_qisxa0(this.ea8_1);
    } else {
      var _unary__edvuaz = this.fa8_1;
      this.fa8_1 = _unary__edvuaz + 1 | 0;
      tmp = this.da8_1(_unary__edvuaz);
    }
    return tmp;
  }
  a5() {
    TGenStack__clear_impl_pali4s(this.ea8_1);
    this.fa8_1 = 0;
  }
  ka8(element) {
    this.ca8_1(element);
    TGenStack__push_impl_9yh33t(this.ea8_1, element);
  }
  la8(elements) {
    var _iterator__ex2g4s = elements.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      this.ka8(element);
    }
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.ea8_1);
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Pool) {
      tmp_0 = equals(this.ea8_1, other.ea8_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.ia8() === other.ia8();
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class ReturnablePool {
  constructor(_reset, gen) {
    var tmp;
    if (_reset === VOID) {
      tmp = ReturnablePool$_init_$lambda_rsm60r;
    } else {
      tmp = _reset;
    }
    _reset = tmp;
    this.ma8_1 = _reset;
    this.na8_1 = gen;
    this.oa8_1 = fastArrayListOf([]);
    var tmp_0 = this;
    var tmp_1 = ReturnablePool$list$lambda(this);
    tmp_0.pa8_1 = Pool.ga8(tmp_1, VOID, ReturnablePool$list$lambda_0(this));
    this.qa8_1 = this.pa8_1.ja8();
  }
  r1() {
    var tmp0 = this.oa8_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var element = this.qa8_1;
    tmp0.d2(element);
    this.qa8_1 = this.pa8_1.ja8();
    return this.qa8_1;
  }
  ra8() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.oa8_1.d9v_1;
    var n = 0;
    while (n < array.length) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[_unary__edvuaz];
      this.pa8_1.ka8(it);
    }
    this.oa8_1.a5();
  }
}
class ConcurrentPool extends Pool {
  constructor(reset, preallocate, gen) {
    return new.target.za8(reset, preallocate, gen);
  }
  static za8(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = ConcurrentPool$_init_$lambda_gqhtk8;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    var $this = this.ga8(reset, preallocate, gen);
    $this.wa8_1 = reset;
    $this.xa8_1 = gen;
    $this.ya8_1 = new NonRecursiveLock();
    return $this;
  }
  ja8() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.ya8_1.i9w_1;
    return super.ja8();
  }
  a5() {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.ya8_1.i9w_1;
    super.a5();
  }
  ka8(element) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.ya8_1.i9w_1;
    super.ka8(element);
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.aa9_1 = function_0;
  }
  pj(a, b) {
    return this.aa9_1(a, b);
  }
  compare(a, b) {
    return this.pj(a, b);
  }
  p5() {
    return this.aa9_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class Companion_8 {
  ba9(comparator, reversed_0) {
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp = Array(16);
    return new TGenPriorityQueue(isArray(tmp) ? tmp : THROW_CCE(), reversed_0 ? reversed(comparator) : comparator);
  }
  ca9(reversed, comparator) {
    return Companion_instance_8.ba9(new sam$kotlin_Comparator$0(comparator), reversed);
  }
  da9(reversed, comparator, $super) {
    reversed = reversed === VOID ? false : reversed;
    return $super === VOID ? this.ca9(reversed, comparator) : $super.ca9.call(this, reversed, comparator);
  }
}
class TGenPriorityQueue$iterator$1 {
  constructor($index, this$0) {
    this.ha9_1 = $index;
    this.ia9_1 = this$0;
  }
  q1() {
    return this.ha9_1._v < this.ia9_1.ga9_1;
  }
  r1() {
    var _unary__edvuaz = this.ha9_1._v;
    this.ha9_1._v = _unary__edvuaz + 1 | 0;
    return _get_value__a43j40(this.ia9_1, _PriorityQueueNode___init__impl__34dlfu(_unary__edvuaz));
  }
  m1p() {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.le();
  }
  s7() {
    return this.m1p();
  }
}
class TGenPriorityQueue {
  constructor(data, comparator) {
    this.ea9_1 = data;
    this.fa9_1 = comparator;
    this.ga9_1 = 0;
  }
  s2() {
    return this.ga9_1;
  }
  ja9() {
    if (this.ga9_1 <= 0)
      throw IndexOutOfBoundsException.ve();
    return this.ea9_1[0];
  }
  pa4(element) {
    this.ga9_1 = this.ga9_1 + 1 | 0;
    ensure_1(this, this.ga9_1);
    var i = _PriorityQueueNode___init__impl__34dlfu(this.ga9_1 - 1 | 0);
    _set_value__lx0xdg(this, i, element);
    while (!_get_isRoot__1006zj(this, i) && gt(this, _get_value__a43j40(this, _get_parent__oo9xup(this, i)), _get_value__a43j40(this, i))) {
      swap_0(this, i, _get_parent__oo9xup(this, i));
      i = _get_parent__oo9xup(this, i);
    }
    return true;
  }
  d2(element) {
    return this.pa4(element);
  }
  ka9() {
    if (this.ga9_1 <= 0)
      throw IndexOutOfBoundsException.ve();
    if (this.ga9_1 === 1) {
      this.ga9_1 = this.ga9_1 - 1 | 0;
      return _get_value__a43j40(this, _PriorityQueueNode___init__impl__34dlfu(0));
    }
    var root = _get_value__a43j40(this, _PriorityQueueNode___init__impl__34dlfu(0));
    _set_value__lx0xdg(this, _PriorityQueueNode___init__impl__34dlfu(0), _get_value__a43j40(this, _PriorityQueueNode___init__impl__34dlfu(this.ga9_1 - 1 | 0)));
    this.ga9_1 = this.ga9_1 - 1 | 0;
    minHeapify(this, 0);
    return root;
  }
  ra4(element) {
    var inductionVariable = 0;
    var last = this.ga9_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.ea9_1[n], element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  qa4(element) {
    var index = this.ra4(element);
    if (index >= 0) {
      this.la9(index);
    }
    return index >= 0;
  }
  z4(element) {
    if (!true)
      return false;
    return this.qa4(element);
  }
  la9(index) {
    var i = _PriorityQueueNode___init__impl__34dlfu(index);
    while (!(_PriorityQueueNode___get_index__impl__b6r7i5(i) === 0)) {
      swap_0(this, i, _get_parent__oo9xup(this, i));
      i = _get_parent__oo9xup(this, i);
    }
    this.ka9();
  }
  ta4(element) {
    var tmp0 = until(0, this.ga9_1);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = tmp0.n3_1;
      var last = tmp0.o3_1;
      if (inductionVariable <= last)
        do {
          var element_0 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = element_0;
          if (equals(_get_value__a43j40(this, _PriorityQueueNode___init__impl__34dlfu(it)), element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element_0 === last));
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  w2(element) {
    if (!true)
      return false;
    return this.ta4(element);
  }
  ua4(elements) {
    var thisSet = toSet(this);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.n1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = elements.p1();
      while (_iterator__ex2g4s.q1()) {
        var element = _iterator__ex2g4s.r1();
        if (!thisSet.w2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  r4(elements) {
    return this.ua4(elements);
  }
  n1() {
    return this.ga9_1 === 0;
  }
  la4(elements) {
    var _iterator__ex2g4s = elements.p1();
    while (_iterator__ex2g4s.q1()) {
      var e = _iterator__ex2g4s.r1();
      this.pa4(e);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !elements.n1();
  }
  t2(elements) {
    return this.la4(elements);
  }
  p1() {
    var index = {_v: 0};
    return new TGenPriorityQueue$iterator$1(index, this);
  }
  toString() {
    return toString(toList(this));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof TGenPriorityQueue) {
      tmp_0 = contentEquals_1(this.ea9_1, other.ea9_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.fa9_1, other.fa9_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode_1(this.ea9_1);
  }
}
class TGenQueue {
  constructor() {
    this.ma9_1 = TGenDeque.ia4();
  }
  s2() {
    return this.ma9_1.s2();
  }
  n1() {
    return this.s2() === 0;
  }
  na9(v) {
    this.ma9_1.ja4(v);
  }
  oa9() {
    return this.ma9_1.zl();
  }
  ta4(element) {
    return this.ma9_1.ta4(element);
  }
  w2(element) {
    if (!true)
      return false;
    return this.ta4(element);
  }
  ua4(elements) {
    return this.ma9_1.ua4(elements);
  }
  r4(elements) {
    return this.ua4(elements);
  }
  p1() {
    return this.ma9_1.p1();
  }
  hashCode() {
    return this.ma9_1.hashCode();
  }
  equals(other) {
    var tmp;
    if (other instanceof TGenQueue) {
      tmp = this.ma9_1.equals(other.ma9_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
}
class Ref$1 {
  pa9(_set____db54di) {
    this.qa9_1 = _set____db54di;
  }
  k3() {
    var tmp = this.qa9_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('value');
    }
  }
}
class Ref$2 {
  constructor($prop) {
    this.ra9_1 = $prop;
  }
  pa9(value) {
    this.ra9_1.set(value);
  }
  k3() {
    return this.ra9_1.get();
  }
}
class ByteRingBuffer {
  constructor(bits) {
    this.ka0_1 = bits;
    this.la0_1 = 1 << this.ka0_1;
    this.ma0_1 = this.la0_1 - 1 | 0;
    this.na0_1 = new Int8Array(this.la0_1);
    this.oa0_1 = 0;
    this.pa0_1 = 0;
    this.qa0_1 = this.la0_1;
    this.ra0_1 = 0;
  }
  sa9() {
    return this.na0_1;
  }
  ta9() {
    return this.oa0_1 & this.ma0_1;
  }
  ua9() {
    return this.pa0_1 & this.ma0_1;
  }
  va9(count) {
    if (count < 0 || count > this.qa0_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.o(toString(message));
    }
    this.pa0_1 = this.pa0_1 + count | 0;
    this.ra0_1 = this.ra0_1 + count | 0;
    this.qa0_1 = this.qa0_1 - count | 0;
  }
  wa9(count) {
    if (count < 0 || count > this.ra0_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException.o(toString(message));
    }
    this.oa0_1 = this.oa0_1 + count | 0;
    this.ra0_1 = this.ra0_1 - count | 0;
    this.qa0_1 = this.qa0_1 + count | 0;
  }
  xa9() {
    var tmp0 = this.ra0_1;
    // Inline function 'kotlin.math.min' call
    var b = this.la0_1 - (this.oa0_1 & this.ma0_1) | 0;
    return Math.min(tmp0, b);
  }
  ya9() {
    var tmp0 = this.qa0_1;
    // Inline function 'kotlin.math.min' call
    var b = this.la0_1 - (this.pa0_1 & this.ma0_1) | 0;
    return Math.min(tmp0, b);
  }
  ya0(consume) {
    while (consume.ra0_1 > 0) {
      var tmp0 = consume.xa9();
      // Inline function 'kotlin.math.min' call
      var b = this.ya9();
      var copySize = Math.min(tmp0, b);
      Memory_instance.aaa(consume.sa9(), consume.ta9(), this.sa9(), this.ua9(), copySize);
      consume.wa9(copySize);
      this.va9(copySize);
    }
  }
  aa1(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.qa0_1;
    var remaining = Math.min(a, size);
    var coffset = offset;
    var totalWrite = 0;
    $l$loop: while (remaining > 0) {
      var tmp0 = remaining;
      // Inline function 'kotlin.math.min' call
      var b = this.ya9();
      var chunkSize = Math.min(tmp0, b);
      if (chunkSize <= 0)
        break $l$loop;
      Memory_instance.aaa(data, coffset, this.na0_1, this.ua9(), chunkSize);
      this.va9(chunkSize);
      coffset = coffset + chunkSize | 0;
      remaining = remaining - chunkSize | 0;
      totalWrite = totalWrite + chunkSize | 0;
    }
    return totalWrite;
  }
  ca1(size) {
    // Inline function 'kotlin.math.min' call
    var a = this.ra0_1;
    var toRead = Math.min(a, size);
    this.oa0_1 = (this.oa0_1 + toRead | 0) & this.ma0_1;
    this.qa0_1 = this.qa0_1 + toRead | 0;
    this.ra0_1 = this.ra0_1 - toRead | 0;
    return toRead;
  }
  da1(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.ra0_1;
    var toRead = Math.min(a, size);
    var readCount = 0;
    var buffer = this.na0_1;
    var mask = this.ma0_1;
    var coffset = offset;
    var lReadPos = this.oa0_1;
    $l$loop: while (true) {
      var tmp0 = toRead;
      // Inline function 'kotlin.math.min' call
      var b = this.xa9();
      var toReadChunk = Math.min(tmp0, b);
      if (toReadChunk <= 0)
        break $l$loop;
      Memory_instance.aaa(buffer, lReadPos & mask, data, coffset, toReadChunk);
      toRead = toRead - toReadChunk | 0;
      coffset = coffset + toReadChunk | 0;
      lReadPos = lReadPos + toReadChunk | 0;
      readCount = readCount + toReadChunk | 0;
    }
    return readCount;
  }
  a5() {
    this.oa0_1 = 0;
    this.pa0_1 = 0;
    this.ra0_1 = 0;
    this.qa0_1 = this.la0_1;
  }
  za9(offset) {
    return this.na0_1[(this.oa0_1 + offset | 0) & this.ma0_1];
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof ByteRingBuffer) {
      tmp_0 = this.ra0_1 === other.ra0_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp0 = this.ra0_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var inductionVariable = 0;
        if (inductionVariable < tmp0)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(this.za9(n) === other.za9(n))) {
              tmp$ret$0 = false;
              break $l$block;
            }
          }
           while (inductionVariable < tmp0);
        tmp$ret$0 = true;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.ea1();
  }
  ea1() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.ra0_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        out = tmp + this.za9(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class RingBuffer extends ByteRingBuffer {}
class ShortRingBuffer {
  constructor(bits) {
    this.fa1_1 = bits;
    this.ga1_1 = 1 << this.fa1_1;
    this.ha1_1 = this.ga1_1 - 1 | 0;
    this.ia1_1 = new Int16Array(this.ga1_1);
    this.ja1_1 = 0;
    this.ka1_1 = 0;
    this.la1_1 = this.ga1_1;
    this.ma1_1 = 0;
    this.na1_1 = new Int16Array(1);
  }
  ua1(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.la1_1;
    var toWrite = Math.min(a, size);
    var inductionVariable = 0;
    if (inductionVariable < toWrite)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.ia1_1[this.ka1_1] = data[offset + n | 0];
        this.ka1_1 = (this.ka1_1 + 1 | 0) & this.ha1_1;
      }
       while (inductionVariable < toWrite);
    this.ma1_1 = this.ma1_1 + toWrite | 0;
    this.la1_1 = this.la1_1 - toWrite | 0;
    return toWrite;
  }
  ta1(data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.ma1_1;
    var toRead = Math.min(a, size);
    var inductionVariable = 0;
    if (inductionVariable < toRead)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        data[offset + n | 0] = this.ia1_1[this.ja1_1];
        this.ja1_1 = (this.ja1_1 + 1 | 0) & this.ha1_1;
      }
       while (inductionVariable < toRead);
    this.la1_1 = this.la1_1 + toRead | 0;
    this.ma1_1 = this.ma1_1 - toRead | 0;
    return toRead;
  }
  a5() {
    this.ja1_1 = 0;
    this.ka1_1 = 0;
    this.ma1_1 = 0;
    this.la1_1 = this.ga1_1;
  }
  za9(offset) {
    return this.ia1_1[(this.ja1_1 + offset | 0) & this.ha1_1];
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof ShortRingBuffer) {
      tmp_0 = this.ma1_1 === other.ma1_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp0 = this.ma1_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var inductionVariable = 0;
        if (inductionVariable < tmp0)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (!(this.za9(n) === other.za9(n))) {
              tmp$ret$0 = false;
              break $l$block;
            }
          }
           while (inductionVariable < tmp0);
        tmp$ret$0 = true;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.ea1();
  }
  ea1() {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.ma1_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        out = tmp + this.za9(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
}
class Companion_9 {}
class TGenStack {
  constructor(items) {
    this.baa_1 = items;
  }
  s2() {
    return _TGenStack___get_size__impl__cvg66t(this.baa_1);
  }
  n1() {
    return TGenStack__isEmpty_impl_bsbpyi(this.baa_1);
  }
  ta4(element) {
    return TGenStack__contains_impl_l8kli6(this.baa_1, element);
  }
  w2(element) {
    return TGenStack__contains_impl_l8kli6_0(this, element);
  }
  ua4(elements) {
    return TGenStack__containsAll_impl_ic9i7r(this.baa_1, elements);
  }
  r4(elements) {
    return TGenStack__containsAll_impl_ic9i7r_0(this, elements);
  }
  p1() {
    return TGenStack__iterator_impl_2pdia5(this.baa_1);
  }
  toString() {
    return TGenStack__toString_impl_s9t5hn(this.baa_1);
  }
  hashCode() {
    return TGenStack__hashCode_impl_l04zom(this.baa_1);
  }
  equals(other) {
    return TGenStack__equals_impl_w9i35u(this.baa_1, other);
  }
}
class SyncPauseable {
  constructor() {
    this.caa_1 = new Lock();
    this.daa_1 = false;
  }
  eaa(value) {
    if (!(this.daa_1 === value)) {
      this.daa_1 = value;
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var tmp0 = this.caa_1;
      $l$block: {
        // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
        tmp0.n9w();
        try {
          this.caa_1.r9w();
          break $l$block;
        }finally {
          tmp0.p9w();
        }
      }
    }
  }
}
class Memory {
  da4(src, srcPos, dst, dstPos, size) {
    var tmp2 = isArray(dst) ? dst : THROW_CCE();
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    arrayCopy(src, tmp2, dstPos, srcPos, endIndex);
  }
  aaa(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  ma2(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  aa3(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
  sa3(src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  }
}
class DoubleVectorArrayList {
  constructor(dimensions, capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.faa_1 = new Mixin();
    this.gaa_1 = dimensions;
    this.haa_1 = DoubleArrayList.ga3(imul(capacity, this.gaa_1));
    this.iaa_1 = false;
  }
  o9u(_set____db54di) {
    this.faa_1.o9u(_set____db54di);
  }
  p9u() {
    return this.faa_1.p9u();
  }
  r9j() {
    return this.gaa_1;
  }
  s2() {
    return this.haa_1.s2() / this.gaa_1 | 0;
  }
  p9j(index, dim) {
    return this.haa_1.u2(imul(index, this.gaa_1) + dim | 0);
  }
  ma3(v0, v1) {
    checkDimensions(this, 2);
    // Inline function 'kotlin.also' call
    this.haa_1.ma3(v0, v1);
    return Unit_instance;
  }
  na3(v0, v1, v2, v3) {
    checkDimensions(this, 4);
    // Inline function 'kotlin.also' call
    this.haa_1.na3(v0, v1, v2, v3);
    return Unit_instance;
  }
  oa3(v0, v1, v2, v3, v4, v5) {
    checkDimensions(this, 6);
    // Inline function 'kotlin.also' call
    this.haa_1.oa3(v0, v1, v2, v3, v4, v5);
    return Unit_instance;
  }
  jaa(index, out, roundDecimalPlaces) {
    appendGenericArray(out, this.gaa_1, DoubleVectorArrayList$vectorToStringBuilder$lambda(this, index, roundDecimalPlaces));
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof DoubleVectorArrayList) {
      tmp_0 = this.gaa_1 === other.gaa_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.haa_1.equals(other.haa_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.haa_1.hashCode();
  }
  toString() {
    return this.kaa(null);
  }
  kaa(roundDecimalPlaces) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.l1();
    this_0.m1('VectorArrayList[' + this.s2() + '](\n');
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.m1(', \n');
        }
        this_0.m1('   ');
        this.jaa(n, this_0, roundDecimalPlaces);
      }
       while (inductionVariable < last);
    this_0.m1('\n)');
    return this_0.toString();
  }
  a5() {
    this.haa_1.a5();
  }
  l9f(other, epsilon) {
    return this.q9j((!(other == null) ? isInterface(other, IDoubleVectorList) : false) ? other : THROW_CCE(), epsilon);
  }
}
class PointList {}
function get_dimensions() {
  return 2;
}
function isEmpty() {
  return this.s2() === 0;
}
function getX(index) {
  return this.p9j(index, 0);
}
function getY(index) {
  return this.p9j(index, 1);
}
function get_1(index) {
  return Vector2D.t9g(this.p9j(index, 0), this.p9j(index, 1));
}
function getComponentList(component, out) {
  var inductionVariable = 0;
  var last = this.s2();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out[n] = this.p9j(n, component);
    }
     while (inductionVariable < last);
  return out;
}
function getComponentList$default(component, out, $super) {
  out = out === VOID ? new Float64Array(this.s2()) : out;
  return $super === VOID ? this.laa(component, out) : getComponentList(component, out);
}
function get_first() {
  return this.u2(0);
}
function get_last() {
  return this.u2(this.s2() - 1 | 0);
}
function contains(p) {
  return this.c9q(p.r9g_1, p.s9g_1);
}
function contains_0(x, y) {
  var inductionVariable = 0;
  var last = this.s2();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (this.l9j(n) === x && this.m9j(n) === y)
        return true;
    }
     while (inductionVariable < last);
  return false;
}
function clone(out) {
  out.raa(this);
  return out;
}
function clone$default(out, $super) {
  out = out === VOID ? new PointArrayList(this.s2()) : out;
  return $super === VOID ? this.naa(out) : clone(out);
}
class Companion_10 {}
class PointArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.oaa_1 = new Mixin();
    this.paa_1 = false;
    this.qaa_1 = DoubleArrayList.ga3(imul(capacity, 2));
  }
  o9u(_set____db54di) {
    this.oaa_1.o9u(_set____db54di);
  }
  p9u() {
    return this.oaa_1.p9u();
  }
  s2() {
    return this.qaa_1.s2() / 2 | 0;
  }
  p9j(index_0, dim) {
    return this.qaa_1.j9u(index(this, index_0, dim));
  }
  l9j(index_0) {
    return this.qaa_1.j9u(index(this, index_0, 0));
  }
  m9j(index_0) {
    return this.qaa_1.j9u(index(this, index_0, 1));
  }
  u2(index_0) {
    var i = index(this, index_0, 0);
    return Vector2D.t9g(this.qaa_1.j9u(i), this.qaa_1.j9u(i + 1 | 0));
  }
  sh() {
    this.qaa_1.a5();
    return this;
  }
  taa(x, y) {
    this.qaa_1.ma3(x, y);
    return this;
  }
  uaa(p) {
    return this.taa(p.r9g_1, p.s9g_1);
  }
  vaa(p) {
    return this.waa(p);
  }
  waa(p) {
    // Inline function 'kotlin.apply' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < p.s2()) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var destruct = p.u2(_unary__edvuaz);
      var x = destruct.jm();
      var y = destruct.km();
      this.taa(x, y);
    }
    return this;
  }
  xaa(p, index) {
    this.taa(p.l9j(index), p.m9j(index));
  }
  raa(other) {
    this.sh();
    this.vaa(other);
    return this;
  }
  naa(out) {
    return out.sh().vaa(this);
  }
  ra2(index_0, count) {
    this.qaa_1.ra2(index(this, index_0, 0), imul(count, 2));
    return this;
  }
  yaa(index, count, $super) {
    count = count === VOID ? 1 : count;
    return $super === VOID ? this.ra2(index, count) : $super.ra2.call(this, index, count);
  }
  equals(other) {
    var tmp;
    if (other instanceof PointArrayList) {
      tmp = this.qaa_1.equals(other.qaa_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return this.qaa_1.hashCode();
  }
  toString() {
    var sb = StringBuilder.l1();
    sb.o1(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _destruct__k2r9zo = this.u2(n);
        var x = _destruct__k2r9zo.jm();
        var y = _destruct__k2r9zo.km();
        if (!(n === 0)) {
          sb.m1(', ');
        }
        sb.o1(_Char___init__impl__6a9atx(40));
        if (x === round(x))
          sb.kh(numberToInt(x));
        else
          sb.nh(x);
        sb.m1(', ');
        if (y === round(y))
          sb.kh(numberToInt(y));
        else
          sb.nh(y);
        sb.o1(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.o1(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
  w2(element) {
    if (!(element instanceof Vector2D))
      return false;
    return this.k9j(element instanceof Vector2D ? element : THROW_CCE());
  }
  l9f(other, epsilon) {
    return this.q9j((!(other == null) ? isInterface(other, IDoubleVectorList) : false) ? other : THROW_CCE(), epsilon);
  }
  r4(elements) {
    return this.i9j(elements);
  }
  y2(element) {
    if (!(element instanceof Vector2D))
      return -1;
    return this.g9j(element instanceof Vector2D ? element : THROW_CCE());
  }
}
class Companion_11 {}
class PointIntArrayList {
  constructor(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    this.zaa_1 = new Mixin();
    this.aab_1 = false;
    this.bab_1 = IntArrayList.za1(capacity);
    this.cab_1 = IntArrayList.za1(capacity);
  }
  o9u(_set____db54di) {
    this.zaa_1.o9u(_set____db54di);
  }
  p9u() {
    return this.zaa_1.p9u();
  }
  s2() {
    return this.bab_1.s2();
  }
  n1() {
    return this.s2() === 0;
  }
  a5() {
    this.bab_1.a5();
    this.cab_1.a5();
  }
  dab(x, y) {
    // Inline function 'kotlin.apply' call
    this.bab_1.ja2(x);
    this.cab_1.ja2(y);
    return this;
  }
  eab(p) {
    return this.dab(p.b9r_1, p.c9r_1);
  }
  l9j(index) {
    return this.bab_1.j9u(index);
  }
  m9j(index) {
    return this.cab_1.j9u(index);
  }
  toString() {
    var sb = StringBuilder.l1();
    sb.o1(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.s2();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x = this.l9j(n);
        var y = this.m9j(n);
        if (!(n === 0)) {
          sb.m1(', ');
        }
        sb.o1(_Char___init__impl__6a9atx(40));
        sb.kh(x);
        sb.m1(', ');
        sb.kh(y);
        sb.o1(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    sb.o1(_Char___init__impl__6a9atx(93));
    return sb.toString();
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function ensureWrite($this, count) {
  if (count <= $this.ua0_1.qa0_1)
    return Unit_instance;
  if (!$this.ta0_1) {
    var message = "Can't grow ByteArrayDeque. Need to write " + count + ', but only ' + $this.ua0_1.qa0_1 + ' is available';
    println('ERROR: ' + message);
    // Inline function 'kotlin.error' call
    throw IllegalStateException.o(toString(message));
  }
  var minNewSize = $this.ua0_1.ra0_1 + count | 0;
  var tmp = $this;
  // Inline function 'kotlin.also' call
  var this_0 = new RingBuffer(ilog2(minNewSize) + 2 | 0);
  this_0.ya0($this.ua0_1);
  tmp.ua0_1 = this_0;
}
function ensureWrite_0($this, count) {
  if (count > $this.pa1_1.la1_1) {
    var minNewSize = $this.pa1_1.ma1_1 + count | 0;
    var newBits = ilog2(minNewSize) + 2 | 0;
    var newRing = new ShortRingBuffer(newBits);
    while ($this.pa1_1.ma1_1 > 0) {
      var read = $this.pa1_1.ta1($this.qa1_1, 0, $this.qa1_1.length);
      newRing.ua1($this.qa1_1, 0, read);
    }
    $this.pa1_1 = newRing;
  }
  return $this;
}
function swap(_this__u8e3s4, lIndex, rIndex) {
  var temp = _this__u8e3s4[lIndex];
  _this__u8e3s4[lIndex] = _this__u8e3s4[rIndex];
  _this__u8e3s4[rIndex] = temp;
}
function rotateRight(_this__u8e3s4, offset) {
  offset = offset === VOID ? 1 : offset;
  var tmp0 = _this__u8e3s4.length;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure._rotateRight' call
    var offset_0 = umod(offset, tmp0);
    if (offset_0 === 0) {
      tmp$ret$0 = Unit_instance;
      break $l$block;
    }
    // Inline function 'kotlin.check' call
    if (!(1 <= offset_0 ? offset_0 < tmp0 : false)) {
      throw IllegalStateException.o('Check failed.');
    }
    reverse(_this__u8e3s4, 0, tmp0);
    reverse(_this__u8e3s4, 0, offset_0);
    reverse(_this__u8e3s4, offset_0, tmp0);
    tmp$ret$0 = Unit_instance;
  }
  return tmp$ret$0;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
function ensure($this, count) {
  if (($this.ua2_1 + count | 0) > $this.ta2_1.length) {
    var tmp = $this;
    var tmp_0 = $this.ta2_1;
    var tmp0 = $this.ua2_1 + count | 0;
    // Inline function 'kotlin.math.max' call
    var b = imul($this.ta2_1.length, 3);
    var tmp$ret$0 = Math.max(tmp0, b);
    var tmp_1 = copyOf_0(tmp_0, tmp$ret$0);
    tmp.ta2_1 = isFloatArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
function floatArrayListOf(values) {
  return FloatArrayList.wa2(values.slice());
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
function ensure_0($this, count) {
  if (($this.fa3_1 + count | 0) > $this.ea3_1.length) {
    var tmp = $this;
    var tmp_0 = $this.ea3_1;
    var tmp0 = $this.fa3_1 + count | 0;
    // Inline function 'kotlin.math.max' call
    var b = imul($this.ea3_1.length, 3);
    var tmp$ret$0 = Math.max(tmp0, b);
    var tmp_1 = copyOf_1(tmp_0, tmp$ret$0);
    tmp.ea3_1 = isDoubleArray(tmp_1) ? tmp_1 : THROW_CCE();
  }
}
function toIntArrayList(_this__u8e3s4) {
  return IntArrayList.ea2(_this__u8e3s4.slice());
}
function doubleArrayListOf(values) {
  return DoubleArrayList.ja3(values.slice());
}
function intArrayListOf(values) {
  return IntArrayList.ea2(values.slice());
}
function reverse_0(_this__u8e3s4, start, end) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.s2() : end;
  return DoubleArrayListSortOps_getInstance().ua3(_this__u8e3s4, start, end - 1 | 0);
}
function sort(_this__u8e3s4, start, end, reversed) {
  start = start === VOID ? 0 : start;
  end = end === VOID ? _this__u8e3s4.s2() : end;
  reversed = reversed === VOID ? false : reversed;
  return genericSort_0(_this__u8e3s4, start, end - 1 | 0, DoubleArrayListSortOps_getInstance(), reversed);
}
var DoubleArrayListSortOps_instance;
function DoubleArrayListSortOps_getInstance() {
  if (DoubleArrayListSortOps_instance === VOID)
    new DoubleArrayListSortOps();
  return DoubleArrayListSortOps_instance;
}
function _get__data__kyoi3c($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.ca4_1;
}
function _get_capacity__a9k9f3($this) {
  return $this.ca4_1.length;
}
function resizeIfRequiredFor($this, count) {
  if (($this.s2() + count | 0) > _get_capacity__a9k9f3($this)) {
    var i = $this.ca4_1;
    var istart = $this.aa4_1;
    var tmp0 = $this.ca4_1.length + 7 | 0;
    var tmp0_0 = $this.s2() + count | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = imul($this.ca4_1.length, 2);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_0 = Math.max(tmp0_0, b);
    // Inline function 'kotlin.arrayOfNulls' call
    var size = Math.max(tmp0, b_0);
    var _o = Array(size);
    var o = isArray(_o) ? _o : THROW_CCE();
    copyCyclic($this, i, istart, o, $this.ba4_1);
    $this.ca4_1 = o;
    $this.aa4_1 = 0;
  }
}
function copyCyclic($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.da4(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.da4(i, 0, o, size1, size2);
  }
}
function _addLast($this, item) {
  $this.ca4_1[($this.aa4_1 + $this.ba4_1 | 0) % _get_capacity__a9k9f3($this) | 0] = item;
  $this.ba4_1 = $this.ba4_1 + 1 | 0;
}
function nullify($this, index) {
  _get__data__kyoi3c($this)[index] = null;
}
function internalIndex($this, index) {
  return umod($this.aa4_1 + index | 0, _get_capacity__a9k9f3($this));
}
function _get__data__kyoi3c_0($this) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return $this.xa4_1;
}
function _get_capacity__a9k9f3_0($this) {
  return $this.xa4_1.length;
}
function resizeIfRequiredFor_0($this, count) {
  if (($this.s2() + count | 0) > _get_capacity__a9k9f3_0($this)) {
    var i = $this.xa4_1;
    var istart = $this.va4_1;
    var tmp0 = $this.xa4_1.length + 7 | 0;
    var tmp0_0 = $this.s2() + count | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = imul($this.xa4_1.length, 2);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_0 = Math.max(tmp0_0, b);
    var tmp$ret$1 = Math.max(tmp0, b_0);
    var _o = new Int32Array(tmp$ret$1);
    var o = isIntArray(_o) ? _o : THROW_CCE();
    copyCyclic_0($this, i, istart, o, $this.wa4_1);
    $this.xa4_1 = o;
    $this.va4_1 = 0;
  }
}
function copyCyclic_0($this, i, istart, o, count) {
  // Inline function 'kotlin.math.min' call
  var a = i.length - istart | 0;
  var size1 = Math.min(a, count);
  var size2 = count - size1 | 0;
  Memory_instance.ma2(i, istart, o, 0, size1);
  if (size2 > 0) {
    Memory_instance.ma2(i, 0, o, size1, size2);
  }
}
function _addLast_0($this, item) {
  $this.xa4_1[($this.va4_1 + $this.wa4_1 | 0) % _get_capacity__a9k9f3_0($this) | 0] = item;
  $this.wa4_1 = $this.wa4_1 + 1 | 0;
}
function nullify_0($this, index) {
  _get__data__kyoi3c_0($this)[index] = 0;
}
function internalIndex_0($this, index) {
  return umod($this.va4_1 + index | 0, _get_capacity__a9k9f3_0($this));
}
function get_keys(_this__u8e3s4) {
  return keys(_this__u8e3s4);
}
function getAndRemove(_this__u8e3s4, key) {
  // Inline function 'kotlin.also' call
  var this_0 = get_2(_this__u8e3s4, key);
  remove(_this__u8e3s4, key);
  return this_0;
}
function translateIndex($this, $receiver) {
  if (!(0 <= $receiver ? $receiver < $this.s2() : false))
    throw IndexOutOfBoundsException.h3('' + $receiver);
  return $this.sa5_1 + $receiver | 0;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function IArray2$asString$lambda(this$0) {
  return (y) => {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this$0.w9z());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.n3_1;
    var last = this_0.o3_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var x = item;
        var tmp$ret$2 = this$0.da0(x, y);
        destination.d2(tmp$ret$2);
      }
       while (!(item === last));
    return joinToString(destination, ', ');
  };
}
function indexOr(_this__u8e3s4, x, y, invalid) {
  invalid = invalid === VOID ? -1 : invalid;
  if (!(0 <= x ? x < _this__u8e3s4.w9z() : false) || !(0 <= y ? y < _this__u8e3s4.x9z() : false))
    return invalid;
  return imul(y, _this__u8e3s4.w9z()) + x | 0;
}
function currentKey($this) {
  switch ($this.ga6_1) {
    case 2147483647:
    case 2147483646:
      return 0;
    default:
      return $this.fa6_1.pa6_1[$this.ga6_1];
  }
}
function currentValue($this) {
  switch ($this.ga6_1) {
    case 2147483647:
      return $this.fa6_1.ma6_1;
    case 2147483646:
      return null;
    default:
      return $this.fa6_1.qa6_1[$this.ga6_1];
  }
}
function nextNonEmptyIndex($this, keys, offset) {
  var inductionVariable = offset;
  var last = keys.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(keys[n] === 0))
        return n;
    }
     while (inductionVariable < last);
  return 2147483646;
}
function next($this) {
  if (!($this.ga6_1 === 2147483646))
    $this.ga6_1 = nextNonEmptyIndex($this, $this.fa6_1.pa6_1, $this.ga6_1 === 2147483647 ? 0 : $this.ga6_1 + 1 | 0);
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq($it) {
  return () => $it.q1();
}
function IntMap$_get_keys_$o$iterator$lambda_bn8atq_0($it) {
  return () => $it.ta6();
}
function IntMap$_get_values_$o$iterator$lambda_ggo058($it) {
  return () => $it.q1();
}
function IntMap$_get_values_$o$iterator$lambda_ggo058_0($it) {
  return () => $it.ua6();
}
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
function _get_stashStart__3psegu($this) {
  return $this.pa6_1.length - $this.oa6_1 | 0;
}
function grow($this) {
  var inc = $this.ia6_1 < 20 ? 3 : 1;
  var newnbits = $this.ia6_1 + inc | 0;
  var new_0 = IntMap.ya6(newnbits, $this.ja6_1, true);
  var inductionVariable = 0;
  var last = $this.pa6_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.pa6_1[n];
      if (!(k === 0)) {
        new_0.za6(k, $this.qa6_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.ia6_1 = new_0.ia6_1;
  $this.ka6_1 = new_0.ka6_1;
  $this.na6_1 = new_0.na6_1;
  $this.oa6_1 = new_0.oa6_1;
  $this.pa6_1 = new_0.pa6_1;
  $this.qa6_1 = new_0.qa6_1;
  $this.ra6_1 = new_0.ra6_1;
}
function growStash($this) {
  $this.oa6_1 = imul($this.oa6_1, 2);
  $this.pa6_1 = copyOf($this.pa6_1, $this.aa7());
  $this.qa6_1 = copyOf_2($this.qa6_1, $this.aa7());
}
function _getKeyIndex($this, key) {
  if (key === 0)
    return $this.la6_1 ? 2147483647 : -1;
  var index1 = hash1($this, key);
  if ($this.pa6_1[index1] === key)
    return index1;
  var index2 = hash2($this, key);
  if ($this.pa6_1[index2] === key)
    return index2;
  var index3 = hash3($this, key);
  if ($this.pa6_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu($this);
  var last = $this.pa6_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.pa6_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot($this, index, key, value) {
  if (!($this.pa6_1[index] === 0))
    throw IllegalStateException.m();
  $this.pa6_1[index] = key;
  $this.qa6_1[index] = value;
  $this.sa6_1 = $this.sa6_1 + 1 | 0;
  return null;
}
function hash1($this, key) {
  return _hash1(key, $this.na6_1);
}
function hash2($this, key) {
  return _hash2(key, $this.na6_1);
}
function hash3($this, key) {
  return _hash3(key, $this.na6_1);
}
function toIntMap(_this__u8e3s4) {
  var out = IntMap.fa7(numberToInt(_this__u8e3s4.s2() * 1.25));
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = _this__u8e3s4.i3().p1();
  while (_iterator__ex2g4s.q1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var k = _destruct__k2r9zo.j3();
    // Inline function 'kotlin.collections.component2' call
    var v = _destruct__k2r9zo.k3();
    out.za6(k, v);
  }
  return out;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function _get_stashStart__3psegu_0($this) {
  return $this.ra7_1.length - $this.qa7_1 | 0;
}
function grow_0($this) {
  var inc = $this.ka7_1 < 20 ? 3 : 1;
  var newnbits = $this.ka7_1 + inc | 0;
  var new_0 = IntIntMap.va7(newnbits, $this.la7_1, true);
  var inductionVariable = 0;
  var last = $this.ra7_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var k = $this.ra7_1[n];
      if (!(k === 0)) {
        new_0.wa7(k, $this.sa7_1[n]);
      }
    }
     while (inductionVariable <= last);
  $this.ka7_1 = new_0.ka7_1;
  $this.ma7_1 = new_0.ma7_1;
  $this.pa7_1 = new_0.pa7_1;
  $this.qa7_1 = new_0.qa7_1;
  $this.ra7_1 = new_0.ra7_1;
  $this.sa7_1 = new_0.sa7_1;
  $this.ta7_1 = new_0.ta7_1;
}
function growStash_0($this) {
  $this.qa7_1 = imul($this.qa7_1, 2);
  $this.ra7_1 = copyOf($this.ra7_1, $this.aa7());
  $this.sa7_1 = copyOf($this.sa7_1, $this.aa7());
}
function _getKeyIndex_0($this, key) {
  if (key === 0)
    return $this.na7_1 ? 2147483647 : -1;
  var index1 = hash1_0($this, key);
  if ($this.ra7_1[index1] === key)
    return index1;
  var index2 = hash2_0($this, key);
  if ($this.ra7_1[index2] === key)
    return index2;
  var index3 = hash3_0($this, key);
  if ($this.ra7_1[index3] === key)
    return index3;
  var inductionVariable = _get_stashStart__3psegu_0($this);
  var last = $this.ra7_1.length;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if ($this.ra7_1[n] === key)
        return n;
    }
     while (inductionVariable < last);
  return -1;
}
function setEmptySlot_0($this, index, key, value) {
  if (!($this.ra7_1[index] === 0))
    throw IllegalStateException.m();
  $this.ra7_1[index] = key;
  $this.sa7_1[index] = value;
  $this.ua7_1 = $this.ua7_1 + 1 | 0;
  return 0;
}
function hash1_0($this, key) {
  return _hash1(key, $this.pa7_1);
}
function hash2_0($this, key) {
  return _hash2(key, $this.pa7_1);
}
function hash3_0($this, key) {
  return _hash3(key, $this.pa7_1);
}
function associateByInt(_this__u8e3s4, block) {
  var n = 0;
  var out = IntMap.fa7();
  var _iterator__ex2g4s = _this__u8e3s4.p1();
  while (_iterator__ex2g4s.q1()) {
    var it = _iterator__ex2g4s.r1();
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    out.za6(block(_unary__edvuaz, it), it);
  }
  return out;
}
function _hash1(key, mask) {
  return _mask(key, mask);
}
function _hash2(key, mask) {
  return _mask(imul(key, 1294968109), mask);
}
function _hash3(key, mask) {
  return _mask(imul(key, 294969449), mask);
}
function _mask(value, mask) {
  return (((value + ((value >>> 8 | 0) & 255) | 0) + ((value >>> 16 | 0) & 255) | 0) + (value >> 24 & 255) | 0) & mask;
}
function Iterator_0(hasNext, next) {
  return new Iterator$1(hasNext, next);
}
var Companion_instance_7;
function Companion_getInstance_7() {
  return Companion_instance_7;
}
function Pool$_init_$lambda_q3cbhr(it) {
  return Unit_instance;
}
function Pool$_init_$lambda_q3cbhr_0(it) {
  return Unit_instance;
}
function ReturnablePool$_init_$lambda_rsm60r(it) {
  return Unit_instance;
}
function ReturnablePool$list$lambda(this$0) {
  return (it) => {
    this$0.ma8_1(it);
    return Unit_instance;
  };
}
function ReturnablePool$list$lambda_0(this$0) {
  return (it) => this$0.na8_1(it);
}
function ConcurrentPool$_init_$lambda_gqhtk8(it) {
  return Unit_instance;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function _set_value__lx0xdg($this, $receiver, value) {
  $this.ea9_1[_PriorityQueueNode___get_index__impl__b6r7i5($receiver)] = value;
}
function _get_value__a43j40($this, $receiver) {
  return $this.ea9_1[_PriorityQueueNode___get_index__impl__b6r7i5($receiver)];
}
function _get_isRoot__1006zj($this, $receiver) {
  return _PriorityQueueNode___get_index__impl__b6r7i5($receiver) === 0;
}
function _get_parent__oo9xup($this, $receiver) {
  return _PriorityQueueNode___init__impl__34dlfu((_PriorityQueueNode___get_index__impl__b6r7i5($receiver) - 1 | 0) / 2 | 0);
}
function _get_left__d9qyp0($this, $receiver) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5($receiver)) + 1 | 0);
}
function _get_right__bvz45n($this, $receiver) {
  return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5($receiver)) + 2 | 0);
}
function gt($this, a, b) {
  return $this.fa9_1.compare(a, b) > 0;
}
function lt($this, a, b) {
  return $this.fa9_1.compare(a, b) < 0;
}
function _get_capacity__a9k9f3_1($this) {
  return $this.ea9_1.length;
}
function ensure_1($this, index) {
  if (index >= _get_capacity__a9k9f3_1($this)) {
    var tmp = $this;
    var tmp_0 = copyOf_2($this.ea9_1, 2 + imul(_get_capacity__a9k9f3_1($this), 2) | 0);
    tmp.ea9_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
}
function minHeapify($this, index) {
  var i = _PriorityQueueNode___init__impl__34dlfu(index);
  $l$loop: while (true) {
    var left = _get_left__d9qyp0($this, i);
    var right = _get_right__bvz45n($this, i);
    var smallest = i;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(left) < $this.ga9_1 && lt($this, _get_value__a43j40($this, left), _get_value__a43j40($this, i)))
      smallest = left;
    if (_PriorityQueueNode___get_index__impl__b6r7i5(right) < $this.ga9_1 && lt($this, _get_value__a43j40($this, right), _get_value__a43j40($this, smallest)))
      smallest = right;
    if (!(smallest === i)) {
      swap_0($this, i, smallest);
      i = smallest;
    } else {
      break $l$loop;
    }
  }
}
function swap_0($this, l, r) {
  var temp = _get_value__a43j40($this, r);
  _set_value__lx0xdg($this, r, _get_value__a43j40($this, l));
  _set_value__lx0xdg($this, l, temp);
}
function _PriorityQueueNode___init__impl__34dlfu(index) {
  return index;
}
function _PriorityQueueNode___get_index__impl__b6r7i5($this) {
  return $this;
}
function Ref(value) {
  // Inline function 'kotlin.also' call
  var this_0 = Ref_0();
  this_0.pa9(value);
  return this_0;
}
function toRef(_this__u8e3s4) {
  return Ref_1(_this__u8e3s4);
}
function Ref_0() {
  return new Ref$1();
}
function Ref_1(prop) {
  return new Ref$2(prop);
}
function _TGenStack___init__impl__yynjgt(items) {
  items = items === VOID ? FastArrayList.f9v() : items;
  return items;
}
function _get_items__fzd5gv($this) {
  return $this;
}
function _TGenStack___get_size__impl__cvg66t($this) {
  return _get_items__fzd5gv($this).s2();
}
function TGenStack__isEmpty_impl_bsbpyi($this) {
  return _TGenStack___get_size__impl__cvg66t($this) === 0;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
function TGenStack__push_impl_9yh33t($this, v) {
  _get_items__fzd5gv($this).d2(v);
}
function TGenStack__pop_impl_qisxa0($this) {
  return _get_items__fzd5gv($this).g5(_get_items__fzd5gv($this).s2() - 1 | 0);
}
function TGenStack__clear_impl_pali4s($this) {
  _get_items__fzd5gv($this).a5();
}
function TGenStack__contains_impl_l8kli6($this, element) {
  return _get_items__fzd5gv($this).w2(element);
}
function TGenStack__contains_impl_l8kli6_0($this, element) {
  if (!true)
    return false;
  return TGenStack__contains_impl_l8kli6($this.baa_1, element);
}
function TGenStack__containsAll_impl_ic9i7r($this, elements) {
  return _get_items__fzd5gv($this).r4(elements);
}
function TGenStack__containsAll_impl_ic9i7r_0($this, elements) {
  return TGenStack__containsAll_impl_ic9i7r($this.baa_1, elements);
}
function TGenStack__iterator_impl_2pdia5($this) {
  return _get_items__fzd5gv($this).p1();
}
function TGenStack__toString_impl_s9t5hn($this) {
  return 'TGenStack(items=' + $this.toString() + ')';
}
function TGenStack__hashCode_impl_l04zom($this) {
  return $this.hashCode();
}
function TGenStack__equals_impl_w9i35u($this, other) {
  if (!(other instanceof TGenStack))
    return false;
  var tmp0_other_with_cast = other instanceof TGenStack ? other.baa_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function contentHashCode_2(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      out = tmp + _this__u8e3s4[src + n | 0] | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_2(_this__u8e3s4, that, src, dst) {
  var tmp0 = dst - src | 0;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var inductionVariable = 0;
    if (inductionVariable < tmp0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$0 = false;
          break $l$block;
        }
      }
       while (inductionVariable < tmp0);
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function contentHashCode_3(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      out = tmp + toRawBits(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_3(_this__u8e3s4, that, src, dst) {
  var tmp0 = dst - src | 0;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var inductionVariable = 0;
    if (inductionVariable < tmp0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$0 = false;
          break $l$block;
        }
      }
       while (inductionVariable < tmp0);
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function contentHashCode_4(_this__u8e3s4, src, dst) {
  // Inline function 'korlibs.datastructure.internal.hashCoder' call
  var count = dst - src | 0;
  var out = 0;
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      out = imul(out, 7);
      var tmp = out;
      out = tmp + numberToInt(_this__u8e3s4[src + n | 0]) | 0;
    }
     while (inductionVariable < count);
  return out;
}
function contentEquals_4(_this__u8e3s4, that, src, dst) {
  var tmp0 = dst - src | 0;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.internal.equaler' call
    var inductionVariable = 0;
    if (inductionVariable < tmp0)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
          tmp$ret$0 = false;
          break $l$block;
        }
      }
       while (inductionVariable < tmp0);
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function fill(_this__u8e3s4, value) {
  var inductionVariable = 0;
  var last = _this__u8e3s4.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      _this__u8e3s4[n] = value;
    }
     while (inductionVariable <= last);
}
function linkedHashMapOf(pairs) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.m7();
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var key = _destruct__k2r9zo.jm();
    var value = _destruct__k2r9zo.km();
    // Inline function 'kotlin.collections.set' call
    this_0.b5(key, value);
  }
  return this_0;
}
function getCyclicOrNull(_this__u8e3s4, index) {
  return _this__u8e3s4.n1() ? null : getOrNull(_this__u8e3s4, umod(index, _this__u8e3s4.s2()));
}
function _BSearchResult___init__impl__em6zam(raw) {
  return raw;
}
function _BSearchResult___get_raw__impl__uyuhf3($this) {
  return $this;
}
function _BSearchResult___get_found__impl__om04iz($this) {
  return _BSearchResult___get_raw__impl__uyuhf3($this) >= 0;
}
function _BSearchResult___get_index__impl__b5kraz($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : -1;
}
function _BSearchResult___get_nearIndex__impl__s8nq43($this) {
  return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : (-_BSearchResult___get_raw__impl__uyuhf3($this) | 0) - 1 | 0;
}
function binarySearch(_this__u8e3s4, v, fromIndex, toIndex) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _this__u8e3s4.s2() : toIndex;
  // Inline function 'korlibs.datastructure.genericBinarySearchResult' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.datastructure.genericBinarySearch' call
    var low = fromIndex;
    var high = toIndex - 1 | 0;
    while (low <= high) {
      var mid = (low + high | 0) / 2 | 0;
      var mval = compareTo(_this__u8e3s4.j9u(mid), v);
      if (mval < 0)
        low = mid + 1 | 0;
      else if (mval > 0)
        high = mid - 1 | 0;
      else {
        tmp$ret$1 = mid;
        break $l$block;
      }
    }
    tmp$ret$1 = (-low | 0) - 1 | 0;
  }
  return _BSearchResult___init__impl__em6zam(tmp$ret$1);
}
function getCyclic(_this__u8e3s4, index) {
  return _this__u8e3s4.u2(umod(index, _this__u8e3s4.s2()));
}
function getCyclic_0(_this__u8e3s4, index) {
  return _this__u8e3s4[umod(index, _this__u8e3s4.length)];
}
function toLinkedMap(_this__u8e3s4) {
  // Inline function 'kotlin.also' call
  var this_0 = LinkedHashMap.m7();
  var _iterator__ex2g4s = _this__u8e3s4.p1();
  while (_iterator__ex2g4s.q1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.r1();
    var key = _destruct__k2r9zo.jm();
    var value = _destruct__k2r9zo.km();
    // Inline function 'kotlin.collections.set' call
    this_0.b5(key, value);
  }
  return this_0;
}
function genericSort(subject, left, right, ops) {
  return genericSort_0(subject, left, right, ops, false);
}
function genericSort_0(subject, left, right, ops, reversed) {
  // Inline function 'kotlin.also' call
  timSort(subject, left, right, ops, reversed);
  return subject;
}
function timSort(arr, l, r, ops, reversed, RUN) {
  RUN = RUN === VOID ? 32 : RUN;
  var n = (r - l | 0) + 1 | 0;
  var progression = step(until(0, n), RUN);
  var inductionVariable = progression.n3_1;
  var last = progression.o3_1;
  var step_0 = progression.p3_1;
  if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + step_0 | 0;
      var tmp = l + i | 0;
      var tmp0 = (i + RUN | 0) - 1 | 0;
      // Inline function 'kotlin.math.min' call
      var b = n - 1 | 0;
      var tmp$ret$0 = Math.min(tmp0, b);
      insertionSort(arr, tmp, l + tmp$ret$0 | 0, ops, reversed);
    }
     while (!(i === last));
  var size = RUN;
  while (size < n) {
    var progression_0 = step(until(0, n), imul(2, size));
    var inductionVariable_0 = progression_0.n3_1;
    var last_0 = progression_0.o3_1;
    var step_1 = progression_0.p3_1;
    if (step_1 > 0 && inductionVariable_0 <= last_0 || (step_1 < 0 && last_0 <= inductionVariable_0))
      do {
        var left = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + step_1 | 0;
        var tmp0_0 = size;
        // Inline function 'kotlin.math.min' call
        var b_0 = (n - left | 0) - 1 | 0;
        var rize = Math.min(tmp0_0, b_0);
        var mid = (left + rize | 0) - 1 | 0;
        var tmp0_1 = (left + imul(2, rize) | 0) - 1 | 0;
        // Inline function 'kotlin.math.min' call
        var b_1 = n - 1 | 0;
        var right = Math.min(tmp0_1, b_1);
        merge(arr, l + left | 0, l + mid | 0, l + right | 0, ops, reversed);
      }
       while (!(left === last_0));
    size = imul(size, 2);
  }
}
function insertionSort(arr, left, right, ops, reversed) {
  var inductionVariable = left + 1 | 0;
  if (inductionVariable <= right)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var m = n - 1 | 0;
      $l$loop: while (m >= left && negateIf(ops.wa3(arr, m, n), reversed) > 0) {
        m = m - 1 | 0;
      }
      m = m + 1 | 0;
      if (!(m === n)) {
        ops.za3(arr, m, n);
      }
    }
     while (!(n === right));
}
function merge(arr, start, mid, end, ops, reversed) {
  var s = start;
  var m = mid;
  var s2 = m + 1 | 0;
  if (negateIf(ops.wa3(arr, m, s2), reversed) <= 0)
    return Unit_instance;
  while (s <= m && s2 <= end) {
    if (negateIf(ops.wa3(arr, s, s2), reversed) <= 0) {
      s = s + 1 | 0;
    } else {
      ops.za3(arr, s, s2);
      s = s + 1 | 0;
      m = m + 1 | 0;
      s2 = s2 + 1 | 0;
    }
  }
}
function negateIf(_this__u8e3s4, doNegate) {
  return doNegate ? -_this__u8e3s4 | 0 : _this__u8e3s4;
}
var Memory_instance;
function Memory_getInstance() {
  return Memory_instance;
}
function checkDimensions($this, dim) {
  if (!(dim === $this.gaa_1)) {
    // Inline function 'kotlin.error' call
    var message = 'Invalid dimensions ' + dim + ' != ' + $this.gaa_1;
    throw IllegalStateException.o(toString(message));
  }
}
function DoubleVectorArrayList$vectorToStringBuilder$lambda(this$0, $index, $roundDecimalPlaces) {
  return ($this$appendGenericArray, it) => {
    var v = this$0.p9j($index, it);
    appendNice($this$appendGenericArray, !($roundDecimalPlaces == null) ? roundDecimalPlaces(v, $roundDecimalPlaces) : v);
    return Unit_instance;
  };
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
function index($this, index, offset) {
  return imul(index, 2) + offset | 0;
}
function pointArrayListOf(p0, p1) {
  return (new PointArrayList(2)).uaa(p0).uaa(p1);
}
function pointArrayListOf_0(p0, p1, p2) {
  return (new PointArrayList(3)).uaa(p0).uaa(p1).uaa(p2);
}
function pointArrayListOf_1(p0, p1, p2, p3) {
  return (new PointArrayList(4)).uaa(p0).uaa(p1).uaa(p2).uaa(p3);
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
function FastIntMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function get_2(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.get(key);
}
function clear(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.clear();
}
function FastIdentityMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function set_1(_this__u8e3s4, key, value) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.set(key, value);
}
function get_size(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function contains_1(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.has(key);
}
function FastStringMap() {
  // Inline function 'kotlin.js.asDynamic' call
  return new Map();
}
function get_size_0(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.size;
}
function keys(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = Array_from(_this__u8e3s4.keys());
  return toList_0(tmp$ret$1);
}
function remove(_this__u8e3s4, key) {
  // Inline function 'kotlin.js.asDynamic' call
  _this__u8e3s4.delete(key);
}
function Array_from(value) {
  return Array.from(value);
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForInterface(IArray2, 'IArray2', VOID, VOID, [Iterable]);
initMetadataForInterface(IntIArray2, 'IntIArray2', VOID, VOID, [IArray2]);
protoOf(IntArray2).p9j = get;
protoOf(IntArray2).ca0 = set;
protoOf(IntArray2).j9u = getAt_0;
protoOf(IntArray2).da0 = getAt;
protoOf(IntArray2).ea0 = inside;
protoOf(IntArray2).ba0 = asString;
initMetadataForClass(IntArray2, 'IntArray2', VOID, VOID, [IntIArray2]);
initMetadataForCompanion(Companion_0);
initMetadataForInterface(FloatIArray2, 'FloatIArray2', VOID, VOID, [IArray2]);
protoOf(FloatArray2).p9j = get_0;
protoOf(FloatArray2).ja0 = set_0;
protoOf(FloatArray2).j9u = getAt_1;
protoOf(FloatArray2).da0 = getAt;
protoOf(FloatArray2).ea0 = inside;
protoOf(FloatArray2).ba0 = asString;
initMetadataForClass(FloatArray2, 'FloatArray2', VOID, VOID, [FloatIArray2]);
initMetadataForClass(ByteArrayDeque, 'ByteArrayDeque', ByteArrayDeque);
initMetadataForClass(ShortArrayDeque, 'ShortArrayDeque', ShortArrayDeque);
initMetadataForCompanion(Companion_1);
initMetadataForClass(IntArrayList, 'IntArrayList', IntArrayList.za1, VOID, [Collection]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(FloatArrayList, 'FloatArrayList', FloatArrayList.va2, VOID, [Collection]);
initMetadataForCompanion(Companion_3);
protoOf(DoubleArrayList).s4 = listIterator;
initMetadataForClass(DoubleArrayList, 'DoubleArrayList', DoubleArrayList.ga3, VOID, [DoubleList]);
initMetadataForClass(SortOps, 'SortOps');
initMetadataForObject(DoubleArrayListSortOps, 'DoubleArrayListSortOps');
initMetadataForClass(TGenDeque$iterator$1);
initMetadataForClass(TGenDeque, 'TGenDeque', TGenDeque.ia4, VOID, [Collection, MutableIterable]);
initMetadataForClass(IntDeque$iterator$1);
initMetadataForClass(IntDeque, 'IntDeque', IntDeque.ca5, VOID, [Collection, MutableIterable]);
initMetadataForClass(FastSmallSet, 'FastSmallSet', FastSmallSet.na5);
initMetadataForClass(GenericSubList, 'GenericSubList', VOID, VOID, [KtList]);
initMetadataForClass(GenericListIterator, 'GenericListIterator');
initMetadataForClass(HistoryStack, 'HistoryStack', HistoryStack);
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(Iterator, 'Iterator');
initMetadataForClass(IntMap$keys$$inlined$Iterable$1, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(IntMap$values$$inlined$Iterable$1, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(IntMap, 'IntMap', IntMap.fa7);
initMetadataForCompanion(Companion_6);
initMetadataForClass(IntIntMap, 'IntIntMap', IntIntMap.xa7);
initMetadataForClass(Iterator$1);
initMetadataForCompanion(Companion_7);
initMetadataForClass(Pool, 'Pool');
initMetadataForClass(ReturnablePool, 'ReturnablePool');
initMetadataForClass(ConcurrentPool, 'ConcurrentPool');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(TGenPriorityQueue$iterator$1);
initMetadataForClass(TGenPriorityQueue, 'TGenPriorityQueue', VOID, VOID, [Collection, MutableIterable]);
initMetadataForClass(TGenQueue, 'TGenQueue', TGenQueue, VOID, [Collection]);
initMetadataForClass(Ref$1);
initMetadataForClass(Ref$2);
initMetadataForClass(ByteRingBuffer, 'ByteRingBuffer');
initMetadataForClass(RingBuffer, 'RingBuffer');
initMetadataForClass(ShortRingBuffer, 'ShortRingBuffer');
initMetadataForCompanion(Companion_9);
initMetadataForClass(TGenStack, 'TGenStack', VOID, VOID, [Collection]);
initMetadataForClass(SyncPauseable, 'SyncPauseable', SyncPauseable);
initMetadataForObject(Memory, 'Memory');
protoOf(DoubleVectorArrayList).q9j = isAlmostEquals;
protoOf(DoubleVectorArrayList).m9f = isAlmostEquals$default;
initMetadataForClass(DoubleVectorArrayList, 'DoubleVectorArrayList', VOID, VOID, [IDoubleVectorList]);
initMetadataForInterface(PointList, 'PointList', VOID, VOID, [IDoubleVectorList, IPointList]);
initMetadataForCompanion(Companion_10);
protoOf(PointArrayList).saa = clone$default;
protoOf(PointArrayList).r9j = get_dimensions;
protoOf(PointArrayList).n1 = isEmpty;
protoOf(PointArrayList).laa = getComponentList;
protoOf(PointArrayList).maa = getComponentList$default;
protoOf(PointArrayList).ma4 = get_first;
protoOf(PointArrayList).na4 = get_last;
protoOf(PointArrayList).k9j = contains;
protoOf(PointArrayList).c9q = contains_0;
protoOf(PointArrayList).o9j = isNotEmpty;
protoOf(PointArrayList).q9j = isAlmostEquals;
protoOf(PointArrayList).m9f = isAlmostEquals$default;
protoOf(PointArrayList).i9j = containsAll;
protoOf(PointArrayList).g9j = indexOf;
protoOf(PointArrayList).p1 = iterator;
protoOf(PointArrayList).s4 = listIterator_0;
protoOf(PointArrayList).x2 = listIterator_1;
protoOf(PointArrayList).t4 = subList;
initMetadataForClass(PointArrayList, 'PointArrayList', PointArrayList, VOID, [PointList]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(PointIntArrayList, 'PointIntArrayList', PointIntArrayList);
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_4 = new Companion_4();
Companion_instance_5 = new Companion_5();
Companion_instance_6 = new Companion_6();
Companion_instance_7 = new Companion_7();
Companion_instance_8 = new Companion_8();
Companion_instance_9 = new Companion_9();
Memory_instance = new Memory();
Companion_instance_10 = new Companion_10();
Companion_instance_11 = new Companion_11();
//endregion
//region block: exports
export {
  _BSearchResult___init__impl__em6zam as _BSearchResult___init__impl__em6zamjg3fd7w2ehe9,
  _BSearchResult___get_found__impl__om04iz as _BSearchResult___get_found__impl__om04iz3bhk3bxb307hs,
  _BSearchResult___get_index__impl__b5kraz as _BSearchResult___get_index__impl__b5kraz22sor0j4icoq6,
  _BSearchResult___get_nearIndex__impl__s8nq43 as _BSearchResult___get_nearIndex__impl__s8nq4314o583ijf6vjx,
  _TGenStack___init__impl__yynjgt as _TGenStack___init__impl__yynjgt1a2ntdq1fkc7u,
  TGenStack__pop_impl_qisxa0 as TGenStack__pop_impl_qisxa01fn0eg90t1fqa,
  TGenStack__push_impl_9yh33t as TGenStack__push_impl_9yh33t1oehqh3y1sfje,
  Companion_instance_0 as Companion_instance3l6feosw3otmo,
  Companion_instance as Companion_instanceanmlix73471t,
  Companion_instance_8 as Companion_instance2cv0yc0w9i6vs,
  SyncPauseable as SyncPauseable20rt0nt3umu2s,
  ByteArrayDeque as ByteArrayDeque2dezgzzyyl6zm,
  ConcurrentPool as ConcurrentPool3ky1e4r5za9ab,
  DoubleArrayList as DoubleArrayList3by0we6lhx26x,
  FastIdentityMap as FastIdentityMap17d14y8i3m5g7,
  FastIntMap as FastIntMapl0pzyavg6uw5,
  FastSmallSet as FastSmallSet2og2j8v2pz4c7,
  FastStringMap as FastStringMap1l1uzdhsfbatm,
  FloatArray2 as FloatArray2beehiaucxmzd,
  GenericListIterator as GenericListIterator397gjg9p2xwl5,
  GenericSubList as GenericSubList2rec7qqyf06nw,
  HistoryStack as HistoryStack2mrikkhc0etuj,
  IntArray2 as IntArray23680o40e0fgt8,
  IntArrayList as IntArrayList3liuagbdnwmna,
  IntDeque as IntDeque2ebok66x2sofm,
  IntIntMap as IntIntMap3mvg5iqgd5t3z,
  IntMap as IntMap2d9g6f5pyaoc2,
  Pool as Pool1zbsw0zhvh8ca,
  Ref_0 as Ref11k43t82thcp3,
  Ref as Ref2y4j4snnxo6gs,
  ReturnablePool as ReturnablePool3rkgvxsckx2u2,
  ShortArrayDeque as ShortArrayDeque13dn2tr6asm80,
  SortOps as SortOps3rp25tm4jbjru,
  TGenQueue as TGenQueue2v9j3ju90xgpv,
  associateByInt as associateByInt3vmv30txx5avl,
  binarySearch as binarySearch1lxbagta5e4q4,
  clear as clear3idbm40uzyume,
  contains_1 as containsrsn76oa0puwr,
  doubleArrayListOf as doubleArrayListOfkj3z9zq4pobs,
  floatArrayListOf as floatArrayListOfa8snvg2p0fhc,
  genericSort as genericSort3vhmyxbppxo3h,
  getAndRemove as getAndRemove1ksxnnren48mb,
  getCyclicOrNull as getCyclicOrNull12fem85bj0m7u,
  getCyclic_0 as getCyclic18d9063nmuul,
  getCyclic as getCyclic28wvgqye98jqx,
  get_2 as get2pw1zlgv5zypd,
  intArrayListOf as intArrayListOf18h0hna7wb0zr,
  get_keys as get_keyswqddktl7cnu2,
  linkedHashMapOf as linkedHashMapOf2w2uhgrq4khrk,
  reverse_0 as reverse22fe0u1pwl2c6,
  rotateRight as rotateRight96vk8nw2c6nx,
  set_1 as set2vuztm9k7ubgo,
  get_size as get_size2tttv7g2u748n,
  get_size_0 as get_size3oaoh8cpamcqc,
  sort as sort23bpsawysis6n,
  swap as swap3upf401qn4fc8,
  toIntArrayList as toIntArrayList3jlt4o6tyleu,
  toIntMap as toIntMapp1jij98esrcm,
  toRef as toRef3av6zm8yavumw,
  DoubleVectorArrayList as DoubleVectorArrayListq54dfthnqi2t,
  PointArrayList as PointArrayList281mrsgyr6ua1,
  PointIntArrayList as PointIntArrayList1s7gare9hr1oh,
  pointArrayListOf_1 as pointArrayListOf36sb9r6prgwk4,
  pointArrayListOf_0 as pointArrayListOf2s9je3njyg83l,
  pointArrayListOf as pointArrayListOf7rbgdbqf3x4b,
};
//endregion
